import {
  ai,
  ui,
  pm,
  media,
  mobile,
  backend,
  digital,
  general,
  english,
  frontend,
  advertising,
  marketing
} from 'src/assets/images';

export interface ISyllabusSection {
  id?: number;
  title: string;
  sections: string[];
}

export enum CourseSortEnum {
  CODING = 0,
  MARKETING = 1,
  AI = 2
}

export interface ICourse {
  id: number;
  image: string;
  duration: number;
  startDate: string;
  sort: CourseSortEnum;
  title: {
    en: string;
    ge: string;
  };
  lesson: number;
  shortDescription: {
    en: string;
    ge: string;
  };
  description: {
    en: string;
    ge: string;
  };
  youWillLearn: {
    en: string | string[];
    ge: string | string[];
  };
  courseFor: {
    en: string | string[];
    ge: string | string[];
  };
  afterCourse: {
    en: string[];
    ge: string[];
  };
  fee: number;
  cover: string;
  syllabus: {
    ge: ISyllabusSection[];
    en: ISyllabusSection[];
    az?: ISyllabusSection[];
  };
  layerCtgr: 'language' | 'coding' | 'digital' | 'marketing' | 'ai';
}

export const COURSES: ICourse[] = [
  {
    id: 30,
    image: general,
    cover: '',
    sort: CourseSortEnum.CODING,
    duration: 7,
    startDate: '26.06.2023',
    title: {
      en: 'General Course in Coding',
      ge: 'პროგრამირების ძირითადი კურსი'
    },
    lesson: 7,
    layerCtgr: 'coding',
    shortDescription: {
      ge: 'კურსი განკუთვნილია ყველა იმ ადამიანისთვის, ვისაც აქვს სურვილი, 0-დან დაიწყოს პროგრამირების სწავლა - ისწავლოს ვებ დეველოპმენტი, პროგრამირების საფუძვლები და მისი ძირითადი პრინციპები.',
      en: 'This course is designed for beginner developers and covers web development and the fundamentals of programming.'
    },
    description: {
      en: "The course aims to provide students with the knowledge and experience they need to create easy- and medium-level web applications with WordPress. Additionally, the course will help you improve your logical thinking skills, which are essential for developers to find effective solutions to problems. In this comprehensive course, you'll also learn how to use HTML/CSS and create code for website structure and design. The main goal of the course is to teach the fundamentals of programming with PHP. By the end of the course, you'll have the necessary skills and knowledge to create functional and visually appealing web applications with WordPress. Each lesson includes a presentation and practical exercises to help students gain knowledge, enhance their skills, and test their learning.",
      ge: 'კურსის მიზანია სტუდენტებს მისცეს საჭირო ცოდნა და პრაქტიკული უნარები, რომ მათ შეძლონ მარტივი და საშუალო სირთულის ვებ აპლიკაციების შექმნა WordPress-ის გამოყენებით. კურსის განმავლობაში გარკვეული დრო დაეთმობა ლოგიკური აზროვნების განვითარებას. ეს ხელს შეუწყობს დეველოპერისთვის ისეთი უნარების განვითარებას, რომელიც დაეხმარება მას მარტივად იპოვოს სწორი გზა პრობლემების გადასაჭრელად. კურსზე სტუდენტი, ასევე შეძლებს შეისწავლოს HTML/CSS, რაც საშუალებას მისცემს მას შექმნას როგორც საიტის ვიზუალური მხარე, ისე მისი სტრუქტურა და ბიზნეს ლოგიკა. კურსის მთავარი მიზანია უზრუნველყოს პროგრამირების საფუძვლების შესწავლა PHP-ის გამოყენებით. თითოეული ლექცია შედგება პრეზენტაციისგან და პრაქტიკული დავალებებისგან, რომელიც დაგეხმარება ახალი ცოდნის მიღებაში, არსებულის გაუმჯობესებაში და შეძენილი ცოდნის შემოწმებაში.'
    },
    courseFor: {
      en: "This course is designed for beginner developers and covers web development and the fundamentals of programming. Throughout the course, you'll learn PHP, making it an excellent option for those too who have some basic programming knowledge and are looking to advance their skills in PHP and WordPress. You can take the course without any basic knowledge",
      ge: 'კურსი განკუთვნილია ყველა იმ ადამიანისთვის, ვისაც აქვს სურვილი, 0-დან დაიწყოს პროგრამირების სწავლა - ისწავლოს ვებ დეველოპმენტი, პროგრამირების საფუძვლები და მისი ძირითადი პრინციპები. კურსის განმავლობაში შეისწავლით პროგრამულ ენას - PHP. ასე რომ კურსზე რეგისტრაცია რეკომენდებულია მათთვისაც, ვისაც გარკვეული ცოდნა უკვე აქვს პროგრამირებაში და სურს PHP-ს და WordPress-ის შესწავლა. კურსის გავლას შეძლებ ყოველგვარი საბაზისო ცოდნის გარეშე.'
    },
    youWillLearn: {
      en: ['HTML/CSS', 'PHP fundamentals', 'WordPress', 'Deployment'],
      ge: ['HTML/CSS', 'PHP-ის საფუძვლები', 'WordPress', 'Deployment']
    },
    afterCourse: {
      en: [
        'pursue a career as a PHP/WordPress junior developer, intern or freelancer',
        'easy and medium-level website development with PHP and WordPress',
        'use your newfound knowledge for real projects',
        'continue learning programming on your own'
      ],
      ge: [
        'დასაქმდე სტაჟიორის ან ჯუნიორის პოზიციაზე PHP/WordPress დეველოპერად ან გახდე თვითდასაქმებული',
        'შექმნა მარტივი და საშუალო სირთულის ვებსაიტები PHP-ის და WordPress-ის დახმარებით',
        'გამოიყენო შეძენილი ცოდნა პრაქტიკაში',
        'დამოუკიდებლად განაგრძო პროგრამირების სწავლა'
      ]
    },
    fee: 599,
    syllabus: {
      ge: [
        {
          title: 'ნაწილი 1 - შესავალი, ინტერნეტი & მარტივი ვებ ტექნოლოგიები',
          sections: [
            'შესავალი პროგრამირებაში',
            'ძირითადი ცნებები, ცვლადები და ოპერატორები',
            'CMS სისტემები და მათი როლი ვებ დეველოპმენტში',
            'მუშაობა scratch-თან'
          ]
        },
        {
          title: 'ნაწილი 2 - Wordpress',
          sections: [
            'შესავალი ვორდპრესში (localwp installation and lookaround)',
            'მუშაობა ვორდპრესში (თემები და პლაგინები, Layouts, Elementor',
            'შესავალი HTML-სა და CSS-ში',
            'მუშაობა HTML/CSS-თან',
            'მუშაობა Git-თან'
          ]
        },
        {
          title: 'ნაწილი 3 - PHP',
          sections: [
            'შესავალი PHP-ში',
            'მონაცემთა ტიპები / ცვლადები და კონსტანტები / მასივები',
            'რელაციური და ლოგიკური ოპერატორები / Switch case',
            'ციკლები',
            'ჩადგმული ციკლები, ორგანზომილებიანი მასივები',
            'ფუნქციები',
            'მუშაობა PHP-თან'
          ]
        },
        {
          title: 'ნაწილი 4 - გაძლიერებული PHP',
          sections: [
            'გაძლიერებული PHP',
            'შესავალი ACF-ში',
            'ACF-ის პრაქტიკული გამოყენება',
            'პრაქტიკული და ჯგუფური მუშაობა'
          ]
        }
      ],
      en: [
        {
          title: 'Block 1 - Introduction, Basic Web Technologies',
          sections: [
            'Introduction to programming',
            'Essential Concepts, Variables and Operators',
            'CMS Systems and their role in web development',
            'Working on scratch'
          ]
        },
        {
          title: 'Block 2 - Wordpress',
          sections: [
            'Introduction to Wordpress',
            'Working in Wordpress',
            'Introduction to HTML and CSS',
            'Working with HTML and CSS',
            'Working with Git'
          ]
        },
        {
          title: 'Block 3 - PHP',
          sections: [
            'Introduction to PHP',
            'Data Types / Variables and Constants / Arrays ',
            'Relational & Logical operators / Switch case',
            'Loops',
            'Nested Loops, Multidimensional Arrays',
            'Functions',
            'Working with PHP'
          ]
        },
        {
          title: 'Block 4 - Advanced PHP',
          sections: [
            'Advanced PHP',
            'Introduction to ACF',
            'Practical usage of ACF',
            'Practical and Group Works'
          ]
        }
      ]
    }
  },
  {
    id: 31,
    // id: 33,
    image: frontend,
    cover: '',
    sort: CourseSortEnum.CODING,
    duration: 3,
    startDate: '26.06.2023',
    title: {
      en: 'Frontend Development',
      ge: 'ფრონტენდ დეველოპმენტი'
    },
    lesson: 3,
    layerCtgr: 'coding',
    shortDescription: {
      ge: 'კურსი განკუთვნილია ყველა იმ ადამიანისთვის, ვისაც მინიმალური ცოდნა უკვე აქვს პროგრამირებაში ან არის დამწყები დეველოპერი და სურს შეისწავლოს ფრონტენდ დეველოპმენტი.',
      en: 'This course is designed for individuals who already have basic programming knowledge, are beginner developers and are interested in web development.'
    },
    description: {
      en: 'The course aims to provide students with the necessary knowledge and practical skills to create dynamic, interactive web applications using React. The first stage of the course will be devoted to learning the basics of the JavaScript language, which is necessary to work with a React application. The course is designed to teach you the basics of the React JavaScript library. The course also offers an understanding of mobile development using React Native, allowing the student to take their first steps in the field. Lectures comprise a presentation and hands-on exercises that help you learn new information, refine your existing skills, and validate your newfound knowledge.',
      ge: 'კურსის მიზანია, სტუდენტებს მისცეს საჭირო ცოდნა და პრაქტიკული უნარები იმისათვის, რომ მათ შეძლონ დინამიკური, ინტერაქტიური ვებ აპლიკაციების შექმნა React-ის გამოყენებით. კურსის პირველი ეტაპი დაეთმობა JavaScript-ის ენის საფუძვლების შესწავლას, რაც აუცილებელია React-ის აპლიკაციასთან სამუშაოდ. კურსი შექმნილია იმისათვის, რომ შეგასწავლოთ React JavaScript ბიბლიოთეკის საფუძვლები. კურსი ასევე მოიცავს შესავალს mobile development-ში React Native ის გამოყენებით, რაც სტუდენტს მისცემს mobile დეველოპმენტში პირველი ნაბიჯების გადადგმის საშუალებას. თითოეული ლექცია შედგება პრეზენტაციისგან და პრაქტიკული დავალებებისგან, რომლებიც დაგეხმარებიან ახალი ცოდნის მიღებაში, არსებულის გაუმჯობესებაში და შეძენილი ცოდნის შემოწმებაში. '
    },
    courseFor: {
      en: `This course is designed for individuals who already have basic programming knowledge, are beginner developers and are interested in web development. Throughout the course, you’ll learn React, making it an excellent option for those who want to learn how to create one-page web applications for desktop and mobile.

      Minimum requirements:
      - HTML/CSS at the basic level
      - Fundamentals of programming
      - Data type
      - Variables
      - Constants
      - Arrays
      - Relational & Logical Operators (if else)
      - Loops (for, while)
      - Functions
      - Git`,
      ge: `კურსი განკუთვნილია ყველა იმ ადამიანისთვის, ვისაც გარკვეული ცოდნა უკვე აქვს პროგრამირებაში ან არის დამწყები დეველოპერი და აინტერესებს ფრონტენდ დეველოპმენტი. კურსი შექმნილია React-ის საფუძვლების შესასწავლად და მობაილ დეველოპმენტის მიმოსახილად. შესაბამისად, იდეალურია მათთვის, ვისაც სურს ისწავლოს როგორ შექმნას თანამედროვე ერთგვერდიანი ვებ აპლიკაციები, რომელიც იმუშავებს როგორც დესკტოპ, ისე მობილურ მოწყობილობებზე.

      კურსის გავლას შეძლებ, თუ გაქვს საბაზისო ცოდნა შემდეგ საკითხებზე:
      - HTML/CSS საბაზისო დონეზე
      - პროგრამირების საფუძვლები
      - მონაცემთა ტიპები, ცვლადები, კონსტანტები, მასივები
      - რელაციური და ლოგიკური პოერატორები (If else)
      - ციკლები (for, while)
      - ფუნქციები
      - Git - ვერსიების კონტროლი
      `
    },
    youWillLearn: {
      en: [
        'Javascript Fundamentals',
        'React fundamentals',
        'Creating Web Applications for Desktop and Mobile',
        'React Router',
        'State Management with Redux library'
      ],
      ge: [
        'JavaScript-ის საფუძვლები',
        'React-ის საფუძვლები',
        'ვებ აპლიკაციების შექმნა დესკტოპ და მობაილ მოწყობილობებისთვის',
        'React Router',
        'State Management-ი Redux ბიბლიოთეკის გამოყენებით'
      ]
    },
    afterCourse: {
      en: [
        'You can start a job as a Frontend React Developer',
        'Create new web applications',
        'Create a dynamic interface with React',
        'Continue learning programming on your own'
      ],
      ge: [
        'დაიწყო მუშაობა Front-End React დეველოპერად',
        'შექმნა დინამიკური ინტერფეისი React-ის გამოყენებით',
        'გამოიყენო ცოდნა ვებ აპლიკაციების შესაქმნელად',
        'დამოუკიდებლად გაიღრმავო ცოდნა და გაიუმჯობესო უნარები React-ის და React Native-ის მიმართულებით'
      ]
    },
    fee: 599,
    // fee: 1,
    syllabus: {
      ge: [
        {
          title: 'ნაწილი 1 - JavaScript-ის საწყისები',
          sections: [
            'JavaScript-ის საწყისები (მონაცემთა ტიპები, JavaScript-ის ცვლადები, statement-ები და expression-ები, ფუნქციები)',
            'მასივები, ობიექტები, ციკლები',
            'ES6+',
            'DOM-ზე მანიპულაციები და Event-ები',
            'ასინქრონული JavaScript-ი (Callbacks, Promises, async/await, event loop)'
          ]
        },
        {
          title: 'ნაწილი 2 - შესავალი React-ში',
          sections: [
            'node და npm-ის მიმოხილვა',
            'react-ის პროექტის ინსტალაცია და გაშვება',
            'საბაზისო react-ის კომპონენტები. კომპონენტებს შორის ურთიერთობა',
            '"state" ობიექტი. კლასზე დაფუძნებულ კომპონენტებთან მუშაობა',
            'როგორ მუშაობს რეაქტი. კომპონენტის სასიცოცხლო ციკლი. რეალური და ვირტუალური DOM-ი',
            'react-ის საბაზისო ჰუკები. (useState, useEffect, useRef)',
            'მომხმარებლისთვის სპეციფიური ჰუკების წერა',
            'react-ის კომპონენტების სტილისტური გაფორმება',
            'მრავალგვერდიანი SPA აპლიკაციების შექმნა react router-ის გამოყენებით',
            'HTTP მოთხოვნები.  CRUD ოპერაციები',
            'Context API-ს გამოყენება.',
            'შესავალი redux-ში ',
            'typescript-ის საფუძვლები',
            'typescript-ის გამოყენება react-ის პროექტში',
            'რა არის React Native? სხვაობა React-თან',
            'List-ები და TextInput',
            'ნავიგაცია React Native-ში',
            'სმარტფონის feature-ები (Camera, Location, Contacts, etc.)'
          ]
        }
      ],
      en: [
        {
          title: 'Block 1 - JavaScript Basics',
          sections: [
            'JavaScript basics (data types, JavaScript variables, statements and expressions, functions)',
            'Working with arrays, objects, loops',
            'ES6+',
            'DOM Manipulations and Events',
            'Asynchronous JavaScript (Callbacks, Promises, async/await, event loop)'
          ]
        },
        {
          title: 'Block 2 - Introduction to React',
          sections: [
            'Node and npm overview',
            'Installing and running basic react project',
            'Basic react components. Communication between components',
            'Introducing "state". Working with Class based components',
            'How react works behind the scenes. Lifecycle methods. Real DOM vs Virtual DOM',
            'Introducing react hooks. (useState, useEffect, useRef)',
            'Writing our custom hooks',
            'Styling react components',
            'Using router to create Multi-Page SPA applications',
            'Sending HTTP Requests. Perform CRUD operations',
            'Consuming Context API',
            'Introduction to redux',
            'Introduction to typescript',
            'Using typescript in react application',
            'What is React Native? Difference with React',
            'Lists and TextInput',
            'Navigation in React Native',
            'Smartphone features (Camera, Location, Contacts, etc.)'
          ]
        }
      ]
    }
  },
  {
    id: 32,
    image: ui,
    cover: '',
    sort: CourseSortEnum.CODING,
    duration: 3,
    startDate: '26.06.2023',
    title: {
      en: 'UX/UI',
      ge: 'UX/UI'
    },
    lesson: 3,
    layerCtgr: 'coding',
    shortDescription: {
      ge: 'კურსი განკუთვნილია მათთვის, ვისაც სურს UX/UI დიზაინის საფუძვლების შესწავლა ან ცოდნის გაღრმავება.',
      en: 'The course is designed for those looking to learn the basics of UX/UI design or further their existing knowledge.'
    },
    description: {
      en: 'The goal of the course is to provide students with UX/UI knowledge at a level that they will be able to continue developing independently and land a job shortly after completing the course. The teaching style will be based on practical examples, for students to soak up knowledge more efficiently. Students will be able to prepare a design on different platforms, a respective design system and build a prototype.',
      ge: 'კურსის მიზანია სტუდენტებს მოკლე დროში მისცეს საჭირო ცოდნა UX/UI დიზაინის შესახებ. კურსის დასრულების შემდეგ, შენ უკვე დამოუკიდებლად შეძლებ სიღრმისეულად განავითარო შენი შესაძლებლობები და დასაქმდე UX/UI დიზაინერის პოიზიციაზე. ამ მიზნის მისაღწევად, კურსის განმავლობაში უმეტესად დრო დაეთმობა პრაქტიკულ მაგალითებზე მუშაობას იმისათვის, რომ მარტივად გამოიყენო მიღებული ცოდნა რეალურ საქმეში. შენ შეძლებ სხვადასხვა პლატფორმისთვის მოამზადო UX/UI დიზაინი, დიზაინ სისტემა და პროტოტიპი.'
    },
    courseFor: {
      en: 'The course is designed for those looking to learn the basics of UX/UI design or further their existing knowledge. The purpose of this course is to provide the student with practical knowledge to help them find their first job. A basic English level is required in order for the student to understand the technical language. The course is also recommended for visual designers who are interested in learning about digital product design or for other types of professionals who are connected to the digital field. ',
      ge: 'კურსი განკუთვნილია მათთვის, ვისაც სურს UX/UI დიზაინის საფუძვლების შესწავლა ან ცოდნის გაღრმავება. კურსის მიზანია, სტუდენტს მისცეს პრაქტიკული ცოდნა, რომელიც დაეხმარება პირველი სამსახურის პოვნაში. კურსის გასავლელად საჭიროა ინგლისური ენის საბაზისო დონეზე ფლობა, რათა სტუდენტმა შეძლოს ტექნიკური ენის გაგება. კურსი რეკომენდებულია დიზაინერისთვის, რომელსაც აინტერესებს ციფრული პროდუქტის დიზაინი და ასევე სხვა პროფესიის ადამიანისთვის, ვისაც შეხება აქვს ციფრულ სფეროსთან. კურსის გავლას შეძლებ ყოველგვარი საბაზისო ცოდნის გარეშე.'
    },
    youWillLearn: {
      en: [
        'Design principles',
        'Design methodologies',
        'Adobe XD',
        'Figma',
        'Various fidelity designs',
        'Mobile app design',
        'Web app design'
      ],
      ge: [
        'დიზაინის პრინციპები',
        'დიზაინის მეთოდოლოგიები',
        'Adobe XD',
        'Figma',
        'სხვადასხვა გარჩევადობის დიზაინი',
        'მობაილ აპლიკაციის დიზაინი',
        'ვებ აპლიკაციის დიზაინი'
      ]
    },
    afterCourse: {
      en: [
        'Use the tools required to build a digital product.',
        'Implement design principles into the interface.',
        'Develop interfaces and systems for multiple devices.',
        'Prototyping, development testing and presentation.',
        'Work as an intern or junior'
      ],
      ge: [
        'შექმნა ციფრული პროდუქტის დიზაინი საჭირო ინსტრუმენტების გამოყენებით',
        'დანერგო დიზაინ პრინციპები ინტერფეისში',
        'შეიმუშაო ინტერფეისი და სისტემები სხვადასხვა მოწყობილობაზე',
        'შექმნა პროტოტიპი, დიზაინის ტესტინგი და პრეზენტაცია',
        'დასაქმდე ინტერნის ან ჯუნიორის პოზიციაზე'
      ]
    },
    fee: 599,
    syllabus: {
      ge: [
        {
          title: 'ნაწილი 1 - შესავალი',
          sections: [
            'კურსის შესავალი, დიზაინის ისტორია და მიმოხილვა',
            'დიზაინ პრინციპები, გეშტალტი, დიზაინ ფიქრი, საბაზისო ევრისტიკა'
          ]
        },
        {
          title: 'ნაწილი 2 - თულები',
          sections: [
            'დიზაინის ხელსაწყოები, XD-ის საბაზისოები',
            'ფერი და ტიპოგრაფია',
            'შესავალი ფიგმაში, ზოგადი მიმოხილვა',
            'პლაგინები და დიზაინის დამატებითი ხელსაწყოები: დამხმარე პლაგინები დიზაინის შესაქმნელად; ბიბლიოთეკების საიტები და მზა ტემპლეიტები.'
          ]
        },
        {
          title: 'ნაწილი 3 - ინტერფეისის დიზაინი და სტრუქტურა',
          sections: [
            'დიზაინის კომპოზიცია',
            'ხშირად გამოყენებადი დიზაინის სტრუქტურა',
            'მომხმარებლის ინტერფეისის კომპონენტები ნაწილი 1'
          ]
        },
        {
          title: 'ნაწილი 4 - Wireframes, Flows, კვლევა და ეთიკა',
          sections: [
            'Wireframing, site maps',
            'მობილური დიზაინი',
            'User personas, user flows, user journeys',
            'დიზაინის ხელმისაწვდომობა და ux ქოფი'
          ]
        },
        {
          title: 'ნაწილი 5 - დიზაინ სისტემა',
          sections: ['დიზაინ სისტემა ']
        },
        {
          title: 'ნაწილი 6 - პორტფოლიო და სატესტო დავალება',
          sections: [
            'როგორ შევქმნათ პორტფოლიო',
            'მობაილ პროექტი/პორტფოლიო',
            'ვებ პროექტი/პორტფოლიო'
          ]
        }
      ],
      en: [
        {
          title: 'Block 1 - Introduction',
          sections: [
            'Introduction to the course, history of design / design classifications',
            'Design principles, gestalt principles, design thinking, basic heuristics'
          ]
        },
        {
          title: 'Block 2 - Tools',
          sections: [
            'Adobe XD',
            'Color, typograhy',
            'Intro to Figma',
            'Figma plugins, templates, other sources of libraries'
          ]
        },
        {
          title: 'Block 3 - Interface design and structure',
          sections: [
            'Design composition',
            'Common design patterns',
            'UI components, icons, buttons, input fields'
          ]
        },
        {
          title: 'Block 4 - Wireframes, Flows, Research and Ethics  ',
          sections: [
            'Wireframing, site maps',
            'Mobile design',
            'UXR',
            'design accessibility/ux writing'
          ]
        },
        {
          title: 'Block 5 - Design system  ',
          sections: ['Design system']
        },
        {
          title: 'Block 6 - Portfolio and test tasks',
          sections: [
            'How to prepare portfolio',
            'Mobile Project/Portfolio',
            'Web Project/Portfolio'
          ]
        }
      ]
    }
  },
  // {
  //   id: 22,
  //   image: mobile,
  //   cover: '',
  //   sort: CourseSortEnum.CODING,
  //   duration: 3,
  //   startDate: '26.06.2023',
  //   title: {
  //     en: 'Mobile Development | React Native',
  //     ge: 'მობაილ დეველოპმენტი | რეაქთ ნეითივი'
  //   },
  //   lesson: 3,
  //   layerCtgr: 'coding',
  //   shortDescription: {
  //     ge: 'კურსი განკუთვნილია ყველა იმ ადამიანისთვის, ვისაც გარკვეული ცოდნა უკვე აქვს პროგრამირებაში და აინტერესებს მობაილ დეველოპმენტი',
  //     en: 'This course is designed for individuals who already have basic programming knowledge and are interested in mobile development'
  //   },
  //   description: {
  //     en: 'The course aims to provide students with the knowledge and experience they need to create easy- and medium-level mobile web applications. In the first part of the course, you will learn JavaScript which is necessary to understand React and React Native. After that, we will dive deeper into React and React Native. Each lesson includes a presentation and practical exercises to help students gain knowledge, enhance their skills, and test their learning.',
  //     ge: 'კურსის პირველი ეტაპი დაეთმობა JavaScript-ის შესწავლას, რომელიც აუცილებელია React-ისა და React Native-ის გასაგებად. ამის შემდეგ კი, უკვე შეძლებ დაეუფლო React-ისა და React Native-ის სიღრმისეულ ცოდნას. თითოეული ლექცია შედგება პრეზენტაციისგან და პრაქტიკული დავალებებისგან, რომელიც დაგეხმარება ახალი ცოდნის მიღებაში, არსებულის გაუმჯობესებაში და შეძენილი ცოდნის შემოწმებაში.'
  //   },
  //   courseFor: {
  //     en: `This course is designed for individuals who already have basic programming knowledge and are interested in mobile development. Throughout the course, you’ll learn JavaScript as a programming language and also, you will understand React ecosystem, including React Native Framework, making it an excellent option for those who want to learn how to create mobile applications.

  //     Minimum requirements:
  //     - HTML/CSS at the basic level
  //     - Fundamentals of programming
  //     - Data type
  //     - Variables
  //     - Constants
  //     - Arrays
  //     - Relational & Logical Operators (if else)
  //     - Loops (for, while)
  //     - Functions
  //     - Git`,
  //     ge: `კურსი განკუთვნილია ყველა იმ ადამიანისთვის, ვისაც გარკვეული ცოდნა უკვე აქვს პროგრამირებაში და აინტერესებს მობაილ დეველოპმენტი. ასევე, JavaScript-ის პროგრამული ენა და React-ის ეკოსისტემა. შესაბამისად, იდეალურია მათთვის, ვისაც სურს ისწავლოს მობაილ აპლიკაციების დამოუკიდებლად შექმნა React Native Framework-ის გამოყენებით.

  //       კურსის გავლას შეძლებ, თუ გაქვს საბაზისო ცოდნა შემდეგ საკითხებზე:
  //       - HTML/CSS საბაზისო დონეზე
  //       - პროგრამირების საფუძვლები
  //       - მონაცემთა ტიპები, ცვლადები, კონსტანტები, მასივები
  //       - რელაციური და ლოგიკური პოერატორები (If else)
  //       - ციკლები (for, while)
  //       - ფუნქციები
  //       - Git - ვერსიების კონტროლი.`
  //   },
  //   youWillLearn: {
  //     en: [
  //       'JavaScript Fundamentals',
  //       'React and React Native fundamental concepts',
  //       'Android and iOS concepts',
  //       'State Management with Redux library'
  //     ],
  //     ge: [
  //       'JavaScript-ის საფუძვლები',
  //       'React და React Native-ის საბაზისო კონცეფციები',
  //       'Android და iOS პლატფორმების კონცეფციები',
  //       'State Management-ს Redux ბიბლიოთეკის გამოყენებით'
  //     ]
  //   },
  //   afterCourse: {
  //     en: [
  //       'You can become Mobile React-Native Developer',
  //       'Create UI for mobile',
  //       'Create animations with Animated API and Reanimated library'
  //     ],
  //     ge: [
  //       'დაიწყო მუშაობა Mobile React-Native დეველოპერად',
  //       'UI-ის აწყობას მობაილ პლატფორმებისათვის',
  //       'შექმნა ანიმაციები Animated API-სა და Reanimated ბიბლიოთეკის გამოყენებით'
  //     ]
  //   },
  //   fee: 599,
  //   syllabus: {
  //     ge: [
  //       {
  //         title: 'ნაწილი 1 - JavaScript-ის საწყისები',
  //         sections: [
  //           'JavaScript-ის საწყისები (მონაცემთა ტიპები, JavaScript-ის ცვლადები, statement-ები და expression-ები, ფუნქციები)',
  //           'მასივები, ობიექტები, ციკლები',
  //           'ES6+',
  //           'DOM მანიპულაციები და Event-ები',
  //           'პრაქტიკული დავალებები',
  //           'ასინქრონული JavaScript (Callbacks, Promises, async/await, event loop)'
  //         ]
  //       },
  //       {
  //         title: 'ნაწილი 2 - მულტიპლატფორმული მობაილ აპლიკაციების დეველოპმენტის მიმოხილვა',
  //         sections: [
  //           'პროექტის შექმნა Expo/ React Native კომპონენტები',
  //           'View, Text, Image, Pressable და სხვა ძირითადი კომპონენტები'
  //         ]
  //       },
  //       {
  //         title: 'ნაწილი 3 - React Native საბაზისო ცოდნა',
  //         sections: [
  //           'კომპონენტების გასტილვა და React Native Layout სპეციფიკაცია',
  //           'react-ის საბაზისო ჰუკები. (useState, useEffect, useRef)',
  //           'ლისტებთან მუშაობა ScrollView, SafeAreaView, KeyboardAVoidingView',
  //           'დიდ მონაცემებთან მუშაობა Flatlist',
  //           'React Native აპლიკაციაში დამატებითი პაკეტების დამატება, React Navigation',
  //           'Stack Navigation სტრუქტურა & მოქმედება',
  //           'Tab Navigation, Modal Screen Stack Navigatior ში',
  //           'Android & IOS სტილის განსხვავებები'
  //         ]
  //       },
  //       {
  //         title: 'ნაწილი 4 - სიღრმისეული თემები',
  //         sections: [
  //           'გლობალური State მენეჯმენტი (Redux სტრუქტურა და გამოყენება)',
  //           'Redux-ის advanced კონცეფციები - ასინქრონულობა და middleware-ები',
  //           'React Native აპლიკაციის Debugging, React Native Debugger & Flipper',
  //           'დამატებითი ჰუკები - useMemo, useCallback, useContext, useReducer',
  //           'აპლიკაციის ანიმირება "Animated" ბიბლიოთეკით',
  //           'აპლიკაციის დაბილდვა და საკუთარ მოწყობილობაზე დაყენება'
  //         ]
  //       }
  //     ],
  //     en: [
  //       {
  //         title: 'Block 1 - JavaScript Basics',
  //         sections: [
  //           'JavaScript basics (data types, JavaScript variables, statements and expressions, functions)',
  //           'Working with arrays, objects, loops',
  //           'ES6+',
  //           'DOM Manipulations and Events',
  //           'Practical Assignments',
  //           'Asynchronous JavaScript (Callbacks, Promises, async/await, event loop)'
  //         ]
  //       },
  //       {
  //         title: 'Block 2 - Crossplatform Mobile App Development Overview',
  //         sections: [
  //           'Creating Expo project / React Native components',
  //           'View text, image and other basic components'
  //         ]
  //       },
  //       {
  //         title: 'Block 3 - React Native Basics',
  //         sections: [
  //           'Component Styling & React Native Layout Specifications',
  //           'Introducing react hooks. (useState, useEffect, useRef)',
  //           'Handling Scrollable list With Scrollview, SafeAreaView, KeyboardAvoidingView',
  //           'Handling big Data with Optimized Flatlist',
  //           'Adding Third Party Packages To React Native App, React Navigation',
  //           'Stack Navigation Structure & Interaction.',
  //           'Tab Navigation, Modal Screen in Stack Navigatior',
  //           'Android & IOS Styling Differences'
  //         ]
  //       },
  //       {
  //         title: 'Block 4 - React Native Advanced Topics',
  //         sections: [
  //           'Global State Management (Redux setup and structure)',
  //           'Advanced Redux Concepts - Async Actions & Middlewares',
  //           'Debugging React Native Apps with React Native Debugger & Flipper',
  //           'Rest of the hooks - useMemo, useCallback, useContext, useReducer',
  //           'Animating the app with Animated Library',
  //           'Building your app and installig on your phone'
  //         ]
  //       }
  //     ]
  //   }
  // },
  {
    id: 33,
    image: pm,
    cover: '',
    sort: CourseSortEnum.CODING,
    duration: 3,
    startDate: '26.06.2023',
    title: {
      en: 'IT Project Management',
      ge: 'IT პროექტების მენეჯმენტი'
    },
    lesson: 3,
    layerCtgr: 'coding',
    shortDescription: {
      ge: 'კურსი განკუთვნილია ყველა იმ ადამიანისთვის, ვისაც აქვს მცირე ან არანაირი გამოცდილება IT პროექტების მენეჯმენტის მიმართულებით.',
      en: 'This course is designed for individuals who already have little or no experience in IT Project Management.'
    },
    description: {
      en: 'The course aims to provide students with knowledge of key principles and concepts of Project Management. You will understand how Project Managers work and what responsibilities they have. The course will help you to improve your professional skills to assess the goals, plans and risks of the projects perfectly. Besides that, you will gain a deep understanding of Agile methodology and Agile manifesto by doing exercises.',
      ge: 'კურსის მიზანია სტუდენტებს მისცეს საჭირო ცოდნა პროექტის მენეჯმენტის ძირითად პრინციპებსა და კონცეფციებზე. ასევე, შენ გაეცნობი პროექტის მენეჯერის ძირითად როლს და პასუხისმგებლობებს - შეძლებ გაიუმჯობესო პრაქტიკული უნარები, რომ სწორად განსაზღვრო პროექტის მიზნები, გეგმები და რისკები. გარდა ამისა, კურსი უზრუნველყოფს Agile მეთოდოლოგიის სიღრმისეულ მიმოხილვას პრაქტიკული მაგალითების საფუძველზე. შენ გაეცნობი Agile მანიფესტს და შეისწავლი ისეთი ხელსაწყოების გამოყენებას, როგორიც არის Jira.'
    },
    courseFor: {
      en: 'This course is designed for individuals who already have little or no experience in IT Project Management. If you are interested in technologies, IT Project specifications, creating digital products, and want to work with the Software Development team then this is the right course for you. You will learn what skills must Scrum Master and Product Owner have to successfully manage IT projects. You can take the course without any basic knowledge',
      ge: 'კურსი განკუთვნილია ყველა იმ ადამიანისთვის, ვისაც აქვს მცირე ან არანაირი გამოცდილება IT პროექტების მენეჯმენტის მიმართულებით. ასევე მათთვის, ვისაც აინტერესებს ტექნოლოგიები, ციფრული პროდუქტების შექმნის პროცესი, IT პროექტების შექმნის სპეციფიკაციები, პროგრამულ უზრუნველყოფაზე მომუშავე გუნდთან ერთად მუშაობა და სურს, აითვისოს IT პროექტების მენეჯმენტის განსხვავებული მიმართულებები - Scrum Master და Product Owner. კურსის გავლას შეძლებ ყოველგვარი საბაზისო ცოდნის გარეშე.'
    },
    youWillLearn: {
      en: [
        'Agile Methodology',
        'Agile@Scale',
        'Scrum Framework',
        'Differences between Scrum and Kanban',
        'Differences between IT Project Management and Product Manager'
      ],
      ge: [
        'Agile მეთოდოლოგიის პრინციპები',
        'Agile@Scale',
        'Scrum Framework',
        'განსხვავებები Scrum-სა და Kanban-ს შორის',
        'განსხვავებები IT პროექტების მენეჯერსა და პროდუქტების მენეჯერს შორის'
      ]
    },
    afterCourse: {
      en: [
        'You can start a job as an IT Project Manager and Scrum Master.',
        'understand what a project is',
        'manage a project',
        'use Scrum methodology',
        'use Scrum and Kanban systems with Jira'
      ],
      ge: [
        'დაიწყო მუშაობა IT პროექტების მენეჯერად ან Scrum Master-ად',
        'გამოიყენო პროექტის შესახებ ცოდნა პრაქტიკაში',
        'გამოიყენო პროექტის მენეჯმენტის ძირითადი მიდგომები',
        'იმუშაო Scrum გუნდში ',
        'იმუშაო Scrum და Kanban სისტემებთან Jira-ს გამოყენებით'
      ]
    },
    fee: 599,
    syllabus: {
      ge: [
        {
          title: 'ბლოკი 1 - პროექტი და პროექტის გუნდი',
          sections: [
            'რა არის პროექტი?',
            'პროექტის მახასიათებლები',
            'განსხვავებები პროექტისა და პროდუქტის მენეჯერს შორის'
          ]
        },
        {
          title: 'ბლოკი 2 - პროგრამული უზრუნველყოფის მართვის მეთოდოლოგიები და ხელსაწყოები',
          sections: [
            'პროგრამული უზრუნველყოფის განვითარების პროცესი',
            'პროექტის მართვის მეთოდოლოგიები',
            'Agile მეთოდოლოგია',
            'პროექტის მართვის პროცესში გამოყენებული ხელსაწყოები',
            'Scrum ფრეიმვორქი ',
            'Scrum პროექტის შექმნა ჯირაში.',
            'სპრინტისა და ბექლოგის მენეჯმენტი ჯირაში',
            'ავტომატური რეპორტები Jira-ში.',
            'განსხვავებები Scrum-ისა და Kanban-ის ფრეიმვორქებს შორის',
            'რა არის SAFe და როდის გამოიყენება ის'
          ]
        },
        {
          title: 'ბლოკი 3 - პროექტების დაგეგმვა Agile პრინციპების გამოყენებით',
          sections: [
            'პროექტების დაგეგმვა Agile პრინციპების გათვალისწინებით',
            'პროექტის ამოცანების პრიორიტეტიზაციის ტექნიკები',
            'მაღალეფექტიანი Agile გუნდები',
            'სტეიკჰოლდერების მოთხოვნების მიღება და მართვა',
            'პროექტის განვითარების მონიტორინგი',
            'პროექტის დახურვა',
            'პროექტების მართვა Start-Up გარემოში.',
            'პროექტების პრეზენტაცია'
          ]
        }
      ],
      en: [
        {
          title: 'Block 1 - Project Definition and Project Team',
          sections: [
            'How do we define a Project?',
            'Project Priorities',
            'Project Manager vs Product Manager'
          ]
        },
        {
          title: 'Block 2 - Project Management Methodologies and Tools',
          sections: [
            'SDLC Process',
            'Project Management Methodologies',
            'Agile Methodology',
            'Project Management Tools: Jira, Monday, Asana, ClickUp, Trello, Teamwork',
            'Scrum Framework',
            'Start a Scrum Project in Jira',
            'Sprint and Backlog Management in Jira',
            'Jira reporting',
            'Scrum vs Kanban',
            'SAFe Solution'
          ]
        },
        {
          title: 'Block 3 - Agile Planning',
          sections: [
            'Better Agile Planning',
            'Task Prioritization Techniques',
            'High Performance Agile Team',
            'Handling Stakeholder Requests',
            'Monitoring Project Implementation',
            'Project Closure',
            'Project Management in Start-Up Process',
            'Project Demos'
          ]
        }
      ]
    }
  },
  {
    id: 34,
    image: backend,
    sort: CourseSortEnum.CODING,
    cover: '',
    duration: 3,
    startDate: '26.06.2023',
    title: {
      en: 'Backend Development | Python',
      ge: 'ბექენდ დეველოპმენტი | პითონი'
    },
    lesson: 3,
    layerCtgr: 'coding',
    shortDescription: {
      ge: 'კურსი განკუთვნილია ყველა იმ ადამიანისთვის, ვისაც გარკვეული ცოდნა უკვე აქვს პროგრამირებაში ან არის დამწყები დეველოპერი და აინტერესებს ბექენდ დეველოპმენტი.',
      en: 'This course is designed for individuals who already have basic programming knowledge, are beginner developers and are interested in backend development.'
    },
    description: {
      en: 'The course aims to provide students with the knowledge and experience they need to create easy and medium level backend web applications. In the first part of the course, you will learn the fundamentals of Python necessary to work with Django apps. The main goal of the course is to teach the fundamentals of Django Web Framework. Each lesson includes a presentation and practical exercises to help students gain knowledge, enhance their skills, and test their learning.',
      ge: 'კურსის მიზანია სტუდენტებს მისცეს საჭირო ცოდნა და პრაქტიკული უნარები, რომ მათ შეძლონ მარტივი და საშუალო სირთულის ბექენდ აპლიკაციების შექმნა და გამართვა. კურსის პირველი ეტაპი დაეთმობა Python-ის ენის საფუძვლების შესწავლას, რაც აუცილებელია Django-ს აპლიკაციების შესაქმნელად და მათზე სამუშაოდ. კურსი შექმნილია იმისათვის, რომ უზრუნველჰყოს Django Web Framework-ის საფუძვლების შესწავლა. თითოეული ლექცია შედგება პრეზენტაციისგან და პრაქტიკული დავალებებისგან, რომელიც დაგეხმარება ახალი ცოდნის მიღებაში, არსებულის გაუმჯობესებაში და შეძენილი ცოდნის შემოწმებაში.'
    },
    afterCourse: {
      en: [
        'You can start a job as a Python Backend Developer',
        'create new backend applications with Django',
        'continue learning programming on your own'
      ],
      ge: [
        'დაიწყო მუშაობა Python Backend დეველოპერად',
        'შექმნა სხვადასხვა სახის ბექენდ აპლიკაციები Django-ს გამოყენებით',
        'დამოუკიდებლად გაიღრმავო ცოდნა და გაიუმჯობესო უნარები Backend მიმართულებით'
      ]
    },
    youWillLearn: {
      en: [
        'Python fundamentals',
        'Django and Django Rest Framework fundamentals',
        'Easy- and medium-level web application development',
        'Working on databases with Django',
        'Creating APIs with Django Rest Framework'
      ],
      ge: [
        'Python-ის საფუძვლები',
        'Django-ს და Django Rest Framework-ის საფუძვლები',
        'საშუალო და მარტივი სირთულის ვებ აპლიკაციების შექმნა',
        'მონაცემთა ბაზებთან მუშაობა Django-ს გამოყენებით',
        'API-ების შექმნა Django Rest Framework-ის გამოყენებით'
      ]
    },
    courseFor: {
      en: `This course is designed for individuals who already have basic programming knowledge, are beginner developers and are interested in backend development. Throughout the course, you’ll learn Python and Djagno, making it an excellent option for those who want to learn how to create web applications and APIs.

      Minimum requirements:
      - Fundamentals of programming
      - Data type
      - Variables
      - Constants
      - Arrays
      - Relational & Logical Operators (if else)
      - Loops (for, while)
      - Functions
      - Git `,
      ge: `კურსი განკუთვნილია ყველა იმ ადამიანისთვის, ვისაც გარკვეული ცოდნა უკვე აქვს პროგრამირებაში ან არის დამწყები დეველოპერი და აინტერესებს ბექენდ დეველოპმენტი. კურსი შექმნილია Python-ის და Django-ს საფუძვლების შესასწავლად. შესაბამისად, იდეალურია მათთვის, ვისაც სურს ისწავლოს ვებ აპლიკაციების და API-ების შექმნა.

        კურსის გავლას შეძლებ, თუ გაქვს საბაზისო ცოდნა შემდეგ საკითხებზე:
        - დაპროგრამების საფუძვლები
        - მონაცემთა ტიპები, ცვლადები, კონსტანტები, მასივები
        - რელაციური და ლოგიკური პოერატორები (If else)
        - ციკლები (for, while)
        - ფუნქციები
        - Git - ვერსიების კონტროლი
      `
    },
    fee: 599,
    syllabus: {
      ge: [
        {
          title: 'ნაწილი 1 - შესავალი პითონის სინტაქსში',
          sections: [
            'მონაცემთა ტიპები, ცვლადები, ოპერატორები, ციკლები, სკოუპები',
            'მონაცემთა სტრუქტურები, გენერატორები, Try/Except ბლოკები, ფაილებთან მუშაობა, მოდულების იმპორტირება',
            'ობიექტზე ორიენტირებული პროგრამირება '
          ]
        },
        {
          title: 'ნაწილი 2 - შესავალი Backend დეველოპმენტში',
          sections: [
            'შესავალი Linux-ის ტერმინალთან მუშაობაში',
            'საჩვენებელი დემო კონსოლ პროგრამა',
            'Django-ს თემფლეითების ენა',
            'Django-ს კონფიგურაცია:ბაზები, მიგრაციები, Request-ები, Middleware-ები',
            'მოდელფორმები, სტატიკური ფაილები, ფორმების ვალიდაცია.',
            'დოკერის ბაზისები',
            'სრული დემო .'
          ]
        },
        {
          title: 'ნაწილი 3 -  API დეველოპმენტი',
          sections: [
            'აუთენთიკაცია (Sessions,API keys,JWT) & Django-ს User მენეჯმენტი',
            'HTTP პროტოკოლი & RESTUL API პრინციპის გათავისება & მონაცემის ფორმატირება (Json,XML)',
            'Django Rest Framework ',
            'API-ს დოკუმენტაცია Swagger-ით, Postman, სატესტო Request-ების გაგზავნა, მიღება',
            'შესავალი ტესტირებაში: Unit Testing, Integration Testing',
            'ლოგირება და დებაგირება Django -ში',
            'პითონისა და Django -ს მაღალი დონის საკითხები.'
          ]
        }
      ],
      en: [
        {
          title: 'Block 1 - Introduction to Python syntax',
          sections: [
            'Data types, variable declarations, operators, loops, functions, Slicing: Scopes, Global, Local, Nonlocal',
            'Comprehensions: List, Dict, Set, generator, Reading/Writing files, Try/Except, importing modules, decorators',
            'OOP'
          ]
        },
        {
          title: 'Block 2 - Introduction to Backend Development',
          sections: [
            'Getting started with Linux terminal ',
            'Demo console application',
            'Django configuration (Database Connectivity, Database Migrations, Django Middle ware, Request and Response)',
            'ModelForms, Static Files Handling, File Upload, Image Handling, Form Validation.',
            'Docker basics',
            'Full Demo (Part 1) '
          ]
        },
        {
          title: 'Block 3 –  API Development',
          sections: [
            'Authentication(Sessions,API keys,JWT) & Django User Management',
            'HTTP Protocol & Understanding RESTFUL APIs & Data Formats: Json,XML',
            'Django Rest Framework ',
            'Documenting API with Swagger & Introduction to Postman,Sending test requests',
            'Introduction to testing: Unit Testing,Integration Testing',
            'Django Logging, Debugging',
            'Python + Django advanced topics'
          ]
        }
      ]
    }
  },
  {
    id: 35,
    image: digital,
    cover: '',
    sort: CourseSortEnum.CODING,
    duration: 3,
    startDate: '26.06.2023',
    title: {
      en: 'Digital Product Testing',
      ge: 'ციფრული პროდუქტების ტესტირება'
    },
    lesson: 3,
    layerCtgr: 'coding',
    shortDescription: {
      ge: 'კურსი განკუთვნილია ყველა იმ ადამიანისთვის, ვისაც აინტერესებს ციფრული პროდუქტები და მათი ტესტირების პროცესი.',
      en: 'This course is designed for individuals who are interested in Digital Products and Product Testing.'
    },
    description: {
      en: 'The course aims to provide students with knowledge and experience in Quality Assurance, Quality Management, Quality Control and Testing. Each lesson includes a presentation and practical exercises to help students gain knowledge, enhance their skills, and test their learning.',
      ge: 'კურსის მიზანია სტუდენტებს მისცეს საჭირო ცოდნა ხარისხის მართვის, უზრუნველყოფის, კონტროლისა და ტესტირების შესახებ. თითოეული ლექცია შედგება პრეზენტაციისგან და პრაქტიკული დავალებებისგან, რომელიც დაგეხმარება ახალი ცოდნის მიღებაში, არსებულის გაუმჯობესებაში და შეძენილი ცოდნის შემოწმებაში.'
    },
    courseFor: {
      en: 'This course is designed for individuals who are interested in Digital Products and Product Testing. Regardless you have little or no experience in creating digital products, you will be able to learn about Quality Assurance and use this knowledge in the workplace. You can take the course without any basic knowledge',
      ge: 'კურსი განკუთვნილია ყველა იმ ადამიანისთვის, ვისაც აინტერესებს ციფრული პროდუქტები და მათი ტესტირების პროცესი. არ აქვს მნიშვნელობა გაქვს თუ არა გამოცდილება ციფრული პროდუქტების შექმნაში - ეს კურსი დაგეხმარება, მიიღო საფუძვლიანი ცოდნა ხარისხის უზრუნველყოფის შესახებ და შეძლო ამ ცოდნის გამოყენება პროფესიულ საქმიანობაში. კურსის გავლას შეძლებ ყოველგვარი საბაზისო ცოდნის გარეშე.'
    },
    youWillLearn: {
      en: [
        'Error Handling Management',
        'Accessibility Testing',
        'Managing Web Interface Automation Instruments',
        'API Testing'
      ],
      ge: [
        'ხარვეზების მართვა',
        'ხელმისაწვდომობის (Accessebility) ტესტირება',
        'ვებ ინტერფეისის ავტომატიზაციის ინსტრუმენტების მართვა',
        'API ტესტირება'
      ]
    },
    afterCourse: {
      en: [
        'Become a QA/QC Tester',
        'create Test Cases with various design techniques',
        'optimize testing processes with various design techniques',
        'plan and execute web and mobile application testing'
      ],
      ge: [
        'დაიწყო მუშაობა QA/QC ტესტერის პოზიციაზე',
        'შეადგინო ტესტქეისები სხვადასხვა დიზაინ ტექნიკის გამოყენებით',
        'ტესტირების პროცესის ოპტიმიზაციას სხვადასხვა დიზაინ ტექნიკების დახმარებით',
        'დაგეგმო და შეასრულო ტესტირება ვებ და მობაილ აპლიკაციებისთვის'
      ]
    },
    fee: 599,
    syllabus: {
      ge: [
        {
          title: 'ნაწილი 1 - ციფრული პროდუქტების QA და ტესტირების მიმოხილვა',
          sections: ['შესავალი: რა არის QA და ტესტირება', 'პასუხისმგებლობა ხარისხზე']
        },
        {
          title: 'ნაწილი 2 - SDLC & STLC',
          sections: [
            'SDLC - პროგრამული უზრუნველყოფის დეველოპმენტის სასიცოცხლო ციკლი',
            'STLC - პროგრამული უზრუნველყოფის ტესტირების სასიცოცხლო ციკლი'
          ]
        },
        {
          title: 'ნაწილი 3 - QA არტეფაქტები',
          sections: ['ტესტ ქეისები, ტესტირების პაკეტები', 'ხარვეზების ანგარიშგება']
        },
        {
          title: 'ნაწილი 4 - ტესტირების დონეები',
          sections: ['კომპონენტის ტესტირება, ინტეგრაციის ტესტირება', 'სისტემური ტესტირება']
        },
        {
          title: 'ნაწილი 5 - ტესტირების ტიპები',
          sections: [
            'ფუნქციური ტესტირება, არა ფუნქციური ტესტირება, ცვლილებასთან დაკავშირებული ტესტირება',
            'სმოუქ, სანითი და რეგრესული ტესტირება'
          ]
        },
        {
          title: 'ნაწილი 6 - ტესტირების ტექნიკები',
          sections: [
            'შავი ყუთის ტესტირება ',
            'თეთრი ყუთის ტესტირება',
            'გამოცდილებაზე დაფუძნებული ტესტირება'
          ]
        },
        {
          title: 'ნაწილი 7 - გლობალიზაცია და ლოკალიზაცია',
          sections: ['გლობალიზაციის ტესტირება', 'ლოკალიზაციის ტესტირება']
        },
        {
          title: 'ნაწილი 8 - ციფრული ხელმისაწვდომობა',
          sections: [
            'რა არის ციფრული ხელმისაწვდომობა, რატომ არის მნიშვნელოვანი',
            'როგორ გავტესტო ხელმისაწვდომობა'
          ]
        },
        {
          title: 'ნაწილი 9 - API ტესტირება',
          sections: ['რა არის API, რა არის API ტესტირება']
        },
        {
          title: 'ნაწილი 10 - ტესტირების ავტომატიზაცია',
          sections: [
            'რა არის ტესტირების ავტომატიზაცია, ავტომატიზებული ტესტირების სასიცოცხლო ციკლი, ტესტირების ავტომატიზაციის კულტურა',
            'ვების ტესტირების ავტომატიზაცია კოდის წერის გარეშე'
          ]
        },
        {
          title: 'ნაწილი 11 - პრაქტიკული',
          sections: ['საჩვენებელი/დემო პროექტი']
        }
      ],
      en: [
        {
          title: 'Block 1 - Digital product QA & testing overview',
          sections: ['Intro: What is QA and testing', 'Responsibility for quality']
        },
        {
          title: 'Block 2 - SDLC & STLC',
          sections: ['SDLC - Software Development Life Cycle', 'STLC - Software Testing Life Cycle']
        },
        {
          title: 'Block 3 - QA artifacts',
          sections: ['Test cases / Test Suites', 'Bug Reports']
        },
        {
          title: 'Block 4 - Test levels',
          sections: ['Component testing, Integration testing', 'System testing Acceptance testing']
        },
        {
          title: 'Block 5 - Test types',
          sections: [
            'Functional testing, Non-functional testing, Change-related testing',
            'Smoke, sanity & Regression testing'
          ]
        },
        {
          title: 'Block 6 - Test techniques',
          sections: ['Black-box Testing', 'White-box Testing', 'Experience Based Testing']
        },
        {
          title: 'Block 7 - Globalization and Localization',
          sections: ['Globalization Testing', 'Localization Testing']
        },
        {
          title: 'Block 8 - Digital Accessibility',
          sections: ['What is accessibility, Why does it matter', 'How to do Acceccibility testing']
        },
        {
          title: 'Block 9 - API Testing',
          sections: ['What is API, What is API Testing']
        },
        {
          title: 'Block 10 - Test Automation',
          sections: [
            'What is Test Automation, Automation Testing Life Cycle, Culture of Test Automation',
            'Code Less Web UI Automation'
          ]
        },
        {
          title: 'Block 11 - Practical',
          sections: ['Practical Part 1']
        }
      ]
    }
  },
  {
    id: 28,
    image: general,
    cover: '',
    sort: CourseSortEnum.CODING,
    duration: 7,
    startDate: '26.06.2023',
    title: {
      en: 'Test',
      ge: 'ტესტო'
    },
    lesson: 7,
    layerCtgr: 'coding',
    shortDescription: {
      ge: 'კურსი განკუთვნილია ყველა იმ ადამიანისთვის, ვისაც აქვს სურვილი, 0-დან დაიწყოს პროგრამირების სწავლა - ისწავლოს ვებ დეველოპმენტი, პროგრამირების საფუძვლები და მისი ძირითადი პრინციპები',
      en: 'This course is designed for beginner developers and covers web development and the fundamentals of programming'
    },
    description: {
      en: "The course aims to provide students with the knowledge and experience they need to create easy- and medium-level web applications with WordPress. Additionally, the course will help you improve your logical thinking skills, which are essential for developers to find effective solutions to problems. In this comprehensive course, you'll also learn how to use HTML/CSS and create code for website structure and design. The main goal of the course is to teach the fundamentals of programming with PHP. By the end of the course, you'll have the necessary skills and knowledge to create functional and visually appealing web applications with WordPress. Each lesson includes a presentation and practical exercises to help students gain knowledge, enhance their skills, and test their learning.",
      ge: 'კურსის მიზანია სტუდენტებს მისცეს საჭირო ცოდნა და პრაქტიკული უნარები, რომ მათ შეძლონ მარტივი და საშუალო სირთულის ვებ აპლიკაციების შექმნა WordPress-ის გამოყენებით. კურსის განმავლობაში გარკვეული დრო დაეთმობა ლოგიკური აზროვნების განვითარებას. ეს ხელს შეუწყობს დეველოპერისთვის ისეთი უნარების განვითარებას, რომელიც დაეხმარება მას მარტივად იპოვოს სწორი გზა პრობლემების გადასაჭრელად. კურსზე სტუდენტი, ასევე შეძლებს შეისწავლოს HTML/CSS, რაც საშუალებას მისცემს მას შექმნას როგორც საიტის ვიზუალური მხარე, ისე მისი სტრუქტურა და ბიზნეს ლოგიკა. კურსის მთავარი მიზანია უზრუნველყოს პროგრამირების საფუძვლების შესწავლა PHP-ის გამოყენებით. თითოეული ლექცია შედგება პრეზენტაციისგან და პრაქტიკული დავალებებისგან, რომელიც დაგეხმარება ახალი ცოდნის მიღებაში, არსებულის გაუმჯობესებაში და შეძენილი ცოდნის შემოწმებაში.'
    },
    courseFor: {
      en: "This course is designed for beginner developers and covers web development and the fundamentals of programming. Throughout the course, you'll learn PHP, making it an excellent option for those too who have some basic programming knowledge and are looking to advance their skills in PHP and WordPress. You can take the course without any basic knowledge",
      ge: 'კურსი განკუთვნილია ყველა იმ ადამიანისთვის, ვისაც აქვს სურვილი, 0-დან დაიწყოს პროგრამირების სწავლა - ისწავლოს ვებ დეველოპმენტი, პროგრამირების საფუძვლები და მისი ძირითადი პრინციპები. კურსის განმავლობაში შეისწავლით პროგრამულ ენას - PHP. ასე რომ კურსზე რეგისტრაცია რეკომენდებულია მათთვისაც, ვისაც გარკვეული ცოდნა უკვე აქვს პროგრამირებაში და სურს PHP-ს და WordPress-ის შესწავლა. კურსის გავლას შეძლებ ყოველგვარი საბაზისო ცოდნის გარეშე.'
    },
    youWillLearn: {
      en: ['HTML/CSS', 'PHP fundamentals', 'WordPress', 'Deployment'],
      ge: ['HTML/CSS', 'PHP-ის საფუძვლები', 'WordPress', 'Deployment']
    },
    afterCourse: {
      en: [
        'pursue a career as a PHP/WordPress junior developer, intern or freelancer',
        'easy and medium-level website development with PHP and WordPress',
        'use your newfound knowledge for real projects',
        'continue learning programming on your own'
      ],
      ge: [
        'დასაქმდე სტაჟიორის ან ჯუნიორის პოზიციაზე PHP/WordPress დეველოპერად ან გახდე თვითდასაქმებული',
        'შექმნა მარტივი და საშუალო სირთულის ვებსაიტები PHP-ის და WordPress-ის დახმარებით',
        'გამოიყენო შეძენილი ცოდნა პრაქტიკაში',
        'დამოუკიდებლად განაგრძო პროგრამირების სწავლა'
      ]
    },
    fee: 1,
    syllabus: {
      ge: [
        {
          title: 'ნაწილი 1 - შესავალი, ინტერნეტი & მარტივი ვებ ტექნოლოგიები',
          sections: [
            'შესავალი პროგრამირებაში',
            'ძირითადი ცნებები, ცვლადები და ოპერატორები',
            'CMS სისტემები და მათი როლი ვებ დეველოპმენტში',
            'მუშაობა scratch-თან'
          ]
        },
        {
          title: 'ნაწილი 2 - Wordpress',
          sections: [
            'შესავალი ვორდპრესში (localwp installation and lookaround)',
            'მუშაობა ვორდპრესში (თემები და პლაგინები, Layouts, Elementor',
            'შესავალი HTML-სა და CSS-ში',
            'მუშაობა HTML/CSS-თან',
            'მუშაობა Git-თან'
          ]
        },
        {
          title: 'ნაწილი 3 - PHP',
          sections: [
            'შესავალი PHP-ში',
            'მონაცემთა ტიპები / ცვლადები და კონსტანტები / მასივები',
            'რელაციური და ლოგიკური ოპერატორები / Switch case',
            'ციკლები',
            'ჩადგმული ციკლები, ორგანზომილებიანი მასივები',
            'ფუნქციები',
            'მუშაობა PHP-თან'
          ]
        },
        {
          title: 'ნაწილი 4 - გაძლიერებული PHP',
          sections: [
            'გაძლიერებული PHP',
            'შესავალი ACF-ში',
            'ACF-ის პრაქტიკული გამოყენება',
            'პრაქტიკული და ჯგუფური მუშაობა'
          ]
        }
      ],
      en: [
        {
          title: 'Block 1 - Introduction, Basic Web Technologies',
          sections: [
            'Introduction to programming',
            'Essential Concepts, Variables and Operators',
            'CMS Systems and their role in web development',
            'Working on scratch'
          ]
        },
        {
          title: 'Block 2 - Wordpress',
          sections: [
            'Introduction to Wordpress',
            'Working in Wordpress',
            'Introduction to HTML and CSS',
            'Working with HTML and CSS',
            'Working with Git'
          ]
        },
        {
          title: 'Block 3 - PHP',
          sections: [
            'Introduction to PHP',
            'Data Types / Variables and Constants / Arrays ',
            'Relational & Logical operators / Switch case',
            'Loops',
            'Nested Loops, Multidimensional Arrays',
            'Functions',
            'Working with PHP'
          ]
        },
        {
          title: 'Block 4 - Advanced PHP',
          sections: [
            'Advanced PHP',
            'Introduction to ACF',
            'Practical usage of ACF',
            'Practical and Group Works'
          ]
        }
      ]
    }
  },
  {
    id: 37,
    image: marketing,
    cover: '',
    sort: CourseSortEnum.MARKETING,
    duration: 3,
    startDate: '26.06.2023',
    title: {
      en: 'Digital Marketing',
      ge: 'ციფრული მარკეტინგი'
    },
    lesson: 3,
    layerCtgr: 'marketing',
    shortDescription: {
      ge: 'კურსის მიზანია, სტუდენტებს მისცეს საჭირო ცოდნა ზოგადად ციფრული  ინდუსტრიისა და კონკრეტულად ციფრული მარკეტინგის შესახებ. კურსი უზრუნველყოფს ციფრული არხების ანალიზს და მათი სტრატეგიულად გამოყენების მეთოდოლოგიებს.',
      en: 'The course is designed for anyone who wants to learn digital advertising and create their own career in this field, or for business owners who want to increase their sales through various advertising channels and strategies.'
    },
    description: {
      en: 'Our Digital Marketing Course offers a comprehensive and practical approach to mastering the core concepts and strategies of digital marketing. Designed for marketers, business owners, and individuals seeking to expand their digital marketing expertise, this course covers a wide range of topics to equip you with the skills needed to thrive in the digital landscape. Throughout the course, you will delve into various areas of digital marketing, including market research, communication strategies, social media content creation, viral trends, digital advertising, SEO, and more. Each module is carefully crafted to provide you with a solid foundation and practical insights into the world of digital marketing.',
      ge: 'კურსის მიზანია, სტუდენტებს მისცეს საჭირო ცოდნა ზოგადად ციფრული  ინდუსტრიისა და კონკრეტულად ციფრული მარკეტინგის შესახებ. კურსის ფარგლებში, მიიღებ თეორიულ ცოდნას. ხოლო, პრაქტიკული მაგალითების საფუძველზე შეძლებ სფეროს სპეციფიკების უკეთ აღქმას. გარდა ამისა, ციფრული მარკეტინგის კურსი დაგემხარება მარკეტინგული მიზნებისა და ამოცანების სწორად განსაზღვრაში. მისი დასრულების შემდეგ, დამოუკიდებლად შეძლებ მიღებული ცოდნა პრაქტიკაში დასახული მიზნების მისაღწევად გამოიყენო. კურსი უზრუნველყოფს ციფრული არხების ანალიზს და მათი სტრატეგიულად გამოყენების მეთოდოლოგიებს'
    },
    courseFor: {
      en: 'This course is ideal for marketers, business owners, entrepreneurs, and individuals who want to enhance their digital marketing knowledge and skills. Whether you are a beginner or have some experience in the field, this course will provide valuable insights and actionable strategies to excel in the digital marketing space.',
      ge: 'კურსი განკუთვნილია ყველა იმ ადამიანისთვის, ვისაც აქვს მცირე ან თუნდაც არანაირი ცოდნა/გამოცდილება ციფრული მარკეტინგის მიმართულებით. ასევე მათთვის, ვისაც სურვილი აქვს შეისწავლოს აქტუალური პროფესიები ციფრულ მარკეტინგში და დასაქმდეს.'
    },
    youWillLearn: {
      en: [
        'Comprehensive understanding of digital marketing and its significance in today`s business landscape',
        'Essential tools and technologies used in digital marketing',
        'Exploration of various digital marketing professions and career opportunities',
        'Purpose and structure of campaign briefs, and step-by-step campaign planning',
        'Market research techniques to identify target audiences and market trends',
        'Effective communication strategies to engage and connect with the audience',
        'Embracing failure as a learning opportunity and failing successfully',
        'Creating a strong brand platform that resonates with the target audience',
        'Leveraging different digital channels effectively',
        'Developing a social media content strategy for brand visibility and engagement',
        'Staying updated with viral trends and their impact on digital marketing in 2023',
        'Overview of digital advertising and its role in the marketing mix',
        'Creating and managing social media advertising campaigns',
        'Mastering Google AdWords and PPC marketing techniques',
        'Targeting and tracking methods to optimize campaign performance',
        'Utilizing analytics for measuring and analyzing digital marketing effectiveness',
        'Introduction to SEO, on-page optimization, keyword research, and copywriting',
        'Understanding off-page optimization and its impact on search engine rankings',
        'Reporting techniques and effective presentation of digital marketing results',
        'Application of learnings through real-world case studies'
      ],
      ge: [
        'ციფრული მარკეტინგის ზოგადი მიმოხილვა',
        'ციფრული არხების არსი და სპეციფიკაციები',
        'ციფრულ სფეროში არსებული პროფესიები',
        'ციფრული მარკეტინგის სერვისები',
        'ციფრული მარკეტინგის სტრატეგიის შემუშავება',
        'ბრიფების წერა და მათზე მუშაობა',
        'საკომუნიკაციო გეგმის შედგენა და ბიუჯეტირება',
        'სწორი საკომუნიკაციო აუდიტორიების და არხების შერჩევა',
        'კონტენტის შექმნის ძირითადი პრინციპები',
        'რეკლამის შექმნის ძირითადი პრინციპები',
        'სარეკლამო არხების სწორად შერჩევა ',
        'ციფრული ხელსაწყოების გამოყენება '
      ]
    },
    afterCourse: {
      ge: [
        'ციფრულ სტრატეგიაზე მუშაობას',
        'საკომუნიკაციო გეგმის შემუშავებას',
        'მიზნების და აუდიტორიის სწორად შერჩევას',
        'სარეკლამო არხების განსხვავებას და ბრენდზე/პროექტზე მორგებას',
        'ბრიფის წაკითხვას და სწორად შედგენას',
        'კონტენტის სტრატეგიულად დაგეგმვას',
        'გექნება საბაზისო ცოდნა:',
        'სოციალური მედია რეკლამის მიმართულებების და აღსრულების შესახებ',
        'Google Adwords/PPC მარკეტინგის გამოყენების შესახებ',
        'SEO კამპანიების პრაქტიკაში დანერგვის შესახებ',
        'კამპანიის ფარგლებში ბიუჯეტების განსაზღვრის შესახებ'
      ],
      en: [
        'Create and implement successful digital marketing campaigns across various channels',
        'Develop data-driven strategies based on market research and consumer insights',
        'Optimize websites and content for search engines to increase visibility and organic traffic',
        'Utilize social media platforms effectively to enhance brand presence and engagement',
        'Implement targeted ad campaigns and understand the basics of digital advertising',
        'Measure and analyze campaign performance using relevant analytics tools and metrics',
        'Create compelling and engaging content that resonates with the target audience',
        'Build a consistent brand identity and effectively communicate the brand`s message',
        'Adapt to emerging trends and technologies in the dynamic digital marketing landscape',
        'Apply practical skills and knowledge gained from case studies to real-world scenarios'
      ]
    },
    fee: 599,
    syllabus: {
      ge: [
        {
          title: 'ნაწილი 1 - ციფრული მარკეტინგის ზოგადი მიმოხილვა',
          sections: [
            'ციფრული მარკეტინგის  მიმოხილვა',
            'ციფრული მარკეტინგის სამუშაო თულები',
            'ციფრული მარკეტინგის განხრები '
          ]
        },
        {
          title: 'ნაწილი 2 - ბაზრის კვლევა და კამპანიის დაგეგმვა',
          sections: [
            'რა არის ბრიფი და რა დანიშნულება აქვს ციფრულ მარკეტინგში',
            'როგორ დავგეგმოთ სარეკლამო კამპანია',
            'ბაზრის კვლევა',
            'საკომუნიკაციო სტრატეგია',
            'ციფრული მარკეტინგის სტარტეგიის შემუშავება'
          ]
        },
        {
          title: 'ნაწილი 3',
          sections: [
            'წარუმატებელი პროექტების განხილვა',
            'ბრენდის პლატფორმის შექმნა',
            'ციფრული არხები',
            'სოციალური მედია კონტენტ სტრატეგია',
            'ვირუსული გავრცელება და 2023 წლის ტრენდები'
          ]
        },
        {
          title: 'ნაწილი 4 - ციფრული ედვერთაიზინგი',
          sections: [
            'ციფრული რეკლამის მიმოხილვა',
            'სოციალური მედია რეკლამა',
            'Google Adwords/PPC მარკეტინგი',
            'სამიზნე აუდიტორიის შერჩევა და ანალიზი',
            'ანალიტიკა'
          ]
        },
        {
          title: 'ნაწილი 5 - SEO ',
          sections: [
            'SEO შესავალი',
            'SEO მთავარი საძიებო სიტყვები',
            'On-page ოპტიმიზაცია',
            'Off-page ოპტიმიზაცია',
            'რეპორტინგი'
          ]
        }
      ],
      en: [
        {
          title: 'Block 1 - General Overview of Digital Marketing',
          sections: [
            'Digital Marketing Overview',
            'Digital Marketing Working Tools',
            'Digital Marketing Professions'
          ]
        },
        {
          title: 'Block 2 - Market Research and Campaign Planning',
          sections: [
            'What is brief for & it`s structure',
            'How to Plan Campaign Step by Step',
            'Market Research',
            'Communication Strategy - Vol.2'
          ]
        },
        {
          title: 'Block 3',
          sections: [
            'How to fail successfully',
            'Creating Brand Platform',
            'Digital channels',
            'Social Media Content Strategy',
            'Virality & Trends 2023'
          ]
        },
        {
          title: 'Block 4 - Digital Advertising ',
          sections: [
            'Overview of digital advertising',
            'Social Media Advertising',
            'Google Adwords/PPC Marketing',
            'Targeting & Tracking',
            'Analytics'
          ]
        },
        {
          title: 'Block 5 - SEO',
          sections: [
            'Introduction to SEO',
            'On-page optimization',
            'SEO Key Word research & Copywriting',
            'Off-page optimization',
            'Reporting'
          ]
        }
      ]
    }
  },
  {
    id: 36,
    image: advertising,
    cover: '',
    sort: CourseSortEnum.MARKETING,
    duration: 3,
    startDate: '26.06.2023',
    title: {
      en: 'Digital Advertising',
      ge: 'ციფრული ედვერთაიზინგი'
    },
    lesson: 3,
    layerCtgr: 'marketing',
    shortDescription: {
      ge: 'კურსი განკუთვნილია ყველა იმ ადამიანისთვის, ვისაც სურს შეისწავლოს ციფრული რეკლამა და შექმნას საკუთარი კარიერა ამ მიმართულებით, ან არის ბიზნესის მფლობელი და სურს გაზარდოს საკუთარი ბიზნესის გაყიდვები სხვადასხვა სარეკლამო არხების და სტრატეგიების დახმარებით',
      en: 'The course is designed for anyone who wants to learn digital advertising and create their own career in this field, or for business owners who want to increase their sales through various advertising channels and strategies.'
    },
    description: {
      en: 'The objective of the course is to educate students on the fundamental principles and reasoning behind the algorithms utilized in advertising platforms. By the end of the course, students will have the ability to conform to new platforms or technologies. The comprehension of advertising platform algorithms provides an edge to students in the Georgian market. Throughout the course, students will examine key digital marketing platforms like Google, DV360, Meta (FB/IG), LinkedIn, among others. They will familiarize themselves with various advertising strategies that depend on different objectives, as well as the techniques employed in real campaigns. The course will also delve into the intricacies of each platform and the ways in which they can be leveraged to accomplish different advertising goals. After completing the course, students will have a grasp of the principles and algorithms of various advertising platforms and be capable of using this knowledge to adapt to new platforms or technologies. This expertise will give them an edge in the Georgian market, which is experiencing a growing demand for professionals in digital marketing and advertising.',
      ge: 'კურსის დასრულების შემდეგ შენ შეძლებ სარეკლამო პლატფორმების ალგორითმის მუშაობის მთავარი პრინციპების და ლოგიკების გაგებას. აღნიშნული ცოდნის მიღების შემდეგ შეძლებ აითვისო ნებისმიერი ახალი პლატფორმა თუ ტექნოლოგია. სარეკლამო პლატფორმების ალგორითმის ცოდნა სქილვილის კურსდამთავრებულებს ანიჭებს უპირატესობას როგორც ქართულ, ისე საერთაშორისო ბაზარზე. კურსის განმავლობაში სიღრმისეულად შეისწავლი ძირითად პლატფორმებს ციფრულ მარკეტინგში, როგორებიცაა : Google, DV360, Meta (Facebook/Instagram),  Linkedin და ა.შ. Გაეცნობი სხვადასხვა მიზნებზე დაფუძნებულ სარეკლამო სტრატეგიებს და მათი რეალურ გარემოში იმპლემენტაციის გზებს. აღნიშნული სტრატეგიების და პლატფორმების სიღრმისეული ცოდნა საშუალებას მოგცემს ყოველთვის იყო კონკურენტებზე ერთი ნაბიჯით წინ. ყოველი ლექცია შედგება პრეზენტაციისგან და პრაქტიკული დავალებისგან, რომელიც დაგეხმარება თითოეულ ეტაპზე გატესტო მიღებული ცოდნა.'
    },
    courseFor: {
      en: 'The course is designed for anyone who wants to learn digital advertising and create their career in this field, or for business owners who want to increase their sales through various advertising channels and strategies',
      ge: 'კურსი განკუთვნილია ყველა იმ ადამიანისთვის, ვისაც სურს შეისწავლოს ციფრული რეკლამის შექმნა და დაიწყოს საკუთარი კარიერა ამ მიმართულებით, ან არის ბიზნესის მფლობელი და სურს გაზარდოს საკუთარი ბიზნესის გაყიდვები სხვადასხვა სარეკლამო არხების და სტრატეგიების დახმარებით'
    },
    youWillLearn: {
      en: [
        'The working principle of different advertising algorithms',
        'Advertising on the Meta (Facebook/Instagram) platform',
        'Meta advertising strategies and proper campaign optimization',
        'Google Advertising / DV360 / Search Ads / Display and Video Ads',
        'Advertising on the Linkedin platform',
        'Email marketing',
        'Results measurement, analytics, and reporting',
        'Creating advertising strategies tailored to sales and various objectives',
        'Website optimization to increase sales',
        'Development and implementation of a full-fledged advertising strategy'
      ],
      ge: [
        'სხვადასხვა სარეკლამო ალგორითმის მუშაობის პრინციპი',
        'რეკლამა Meta (Facebook/Instagram) პლატფორმაზე',
        'Meta რეკლამის სტრატეგიები და კამპანიის სწორი ოპტიმიზება',
        'Google Advertising / DV360 / Search Ads / Display and Video Ads',
        'რეკლამა Linkedin პლატფორმაზე',
        'Email მარკეტინგი',
        'შედეგების გაზომვა, ანალიტიკა და რეპორტინგი',
        'გაყიდვებზე და სხვადასხვა მიზნებზე მორგებული სარეკლამო სტრატეგიების შექმნა',
        'ვებსაიტის ოპტიმიზება გაყიდვების გასაზრდელად',
        'სრულფასოვანი სარეკლამო სტრატეგიის შემუშავება და განხორციელება'
      ]
    },
    afterCourse: {
      en: [
        'You will be able to start working as a junior digital marketer or advertiser, with the knowledge of an advertiser at a medium level',
        'Increase your business sales through digital channels',
        'Succeed in passing the official exams of Meta and Google and obtain certification'
      ],
      ge: [
        'დაიწყო მუშაობა ციფრული მარკეტერის ან ედვერთაიზერის ჯუნიორ პოზიციაზე',
        'განავითარო შენი ბიზნესი ციფრულ არხებში და გაზარდო გაყიდვების რაოდენობა',
        'წარმატებით ჩააბარო Meta-ს და Google-ის ოფიციალური გამოცდები და მიიღო სერტიფიკატი'
      ]
    },
    fee: 599,
    syllabus: {
      ge: [
        {
          title: 'ნაწილი 1',
          sections: [
            'შესავალი ციფრულ მარკეტინგში',
            'ციფრული რეკლამის მიმოხილვა',
            'სოციალური მედია მარკეტინგი',
            'Meta-ს რეკლამა',
            'მეტა-ს ალგორითმი და რეკლამა',
            'Meta-ს სარეკლამო ძაბრის შექმნა და ეფექტური კამპანიების დაგეგმვა'
          ]
        },
        {
          title: 'ნაწილი 2',
          sections: [
            'ლინკდინის რეკლამა',
            'სარეკლამო კონტენტი რეკლამირებისთვის',
            'PPC რეკლამა',
            'გუგლის საძიებოს სისტემის რეკლამა',
            'Google რეკლამა - ალგორითმი'
          ]
        },
        {
          title: 'ნაწილი 3',
          sections: [
            'თარგეთირების და ბიდინგის სტარტეგიები PPC კამპანიებში',
            'დისფლეი და ვიდეო რეკლამა / პროგრამატიკები',
            'იმეილ მარკეტინგი',
            'ეფექტური იმეილ მარკეტინგის კამპანიების შექმნა და გაზომვა',
            'სარეკლამო კვლევა'
          ]
        },
        {
          title: 'ნაწილი 4',
          sections: [
            'ბრიფიდან მედია გეგმამდე',
            'ციფრული მარკეტინგის კომპლექსური სტრატეგიები',
            'ციფრული მარკეტინგის ხელსაწყოები',
            'ტრეკინგი'
          ]
        },
        {
          title: 'ნაწილი 5',
          sections: [
            'ანალიტიკა და რეპორტინგი',
            'AI და ციფრული რეკალამა',
            'Meta Blueprint და Google Digital Garage სერტიფიკატები',
            'შეჯამება და ფინალური პროექტი'
          ]
        }
      ],
      en: [
        {
          title: 'Block 1',
          sections: [
            'Introduction to digital marketing',
            'Overview of digital advertising',
            'Social media marketing',
            'Meta advertising',
            'Meta algorithm and advertising',
            'Creating Meta advertising funnel and effective campaigns'
          ]
        },
        {
          title: 'Block 2',
          sections: [
            'Linkedin Advertising',
            'Content for advertising',
            'PPC Advertising',
            'Creating Google search Ads',
            'Google Ads - Algorithm'
          ]
        },
        {
          title: 'Block 3',
          sections: [
            'Targeting and bidding strategies for PPC campaigns',
            'Display and video advertising / Programatics ',
            'Email Marketing',
            'Creating effective Email campaigns and measurment',
            'Advertising research'
          ]
        },
        {
          title: 'Block 4',
          sections: [
            'From Brief to Media Plan',
            'Digital advertising advanced strategies',
            'Digital marketing tools',
            'Tracking '
          ]
        },
        {
          title: 'Block 5',
          sections: [
            'Analytics and measurement',
            'Using AI in digital advertising',
            'Meta Blueprint and Google Digital Garage Certifications',
            'Conclusion and final project'
          ]
        }
      ]
    }
  },
  {
    id: 38,
    image: media,
    cover: '',
    sort: CourseSortEnum.MARKETING,
    duration: 3,
    startDate: '26.06.2023',
    title: {
      en: 'Social Media Management',
      ge: 'სოციალური მედიის მართვა'
    },
    lesson: 3,
    layerCtgr: 'marketing',
    shortDescription: {
      ge: 'კურსი განკუთვნილია მარკეტინგით დაინტერესებული პირებისთვის, ბიზნესის მფლობელებისთვის და ყველასთვის, ვინც ცდილობს გაიღრმაოს ცოდნა ციფრული მარკეტინგის მიმართულებით, უფრო კონკრეტულად კი მიიღოს გამოცდილება და შესაბამისი  უნარები კონტენტის შექმნასა და სტრატეგიის დაგეგმვაში. არ აქვს მნიშვნელობა დამწყები ხარ, თუ გაქვს გარკვეული გამოცდილება სოციალური მედიის მართვაში, ეს კურსი მოგცემს სრულყოფილ ცოდნას სხვადასხვა სოციალურ მედია პლატფორმებზე',
      en: 'The course is for marketing enthusiasts, business owners and anyone who wants to deepen their knowledge of digital marketing, and more specifically learn and acquire relevant skills in content creation and strategy planning. It doesn`t matter if you are new to social media management or not, this course will give you a thorough knowledge of various social media platforms'
    },
    description: {
      en: 'Over the course, students will learn how to plan effective content marketing strategies, how to establish a brand`s tone of voice for different digital platforms, and how to use the latest trends and tricks to capture the attention of one`s audience. Each lesson includes a presentation and practical exercises that will help you gain and deepen your knowledge.',
      ge: 'კურსის განმავლობაში შენ შეისწავლი თუ როგორ უნდა დაგეგმოთ კონტენტ მარკეტინგის ეფექტური სტრატეგიები, როგორ ჩამოაყალიბო შენი ბრენდის სასაუბრო ტონი სხვადასხვა ციფრული პლატფორმისთვის და როგორ გამოიყენო უახლესი ტენდენციები და ხრიკები აუდიტორიის ყურადღების მისაქცევად. თითოეული გაკვეთილი მოიცავს პრეზენტაციას და პრაქტიკულ სავარჯიშოებს, რაც დაგეხმარება ცოდნის მიღებასა და გაღრმავებაში'
    },
    courseFor: {
      en: 'The course is for marketing enthusiasts, business owners and anyone who wants to deepen their knowledge of digital marketing, and more specifically learn and acquire relevant skills in content creation and strategy planning. It doesn`t matter if you are new to social media management or not, this course will give you a thorough knowledge of various social media platforms',
      ge: 'კურსი განკუთვნილია მარკეტინგით დაინტერესებული პირებისთვის, ბიზნესის მფლობელებისთვის და ყველასთვის, ვინც ცდილობს გაიღრმაოს ცოდნა ციფრული მარკეტინგის მიმართულებით, უფრო კონკრეტულად კი მიიღოს გამოცდილება და შესაბამისი  უნარები კონტენტის შექმნასა და სტრატეგიის დაგეგმვაში'
    },
    youWillLearn: {
      en: [
        'The basics of content marketing',
        'Current marketing trends and best practices',
        'Creation and management of content on Facebook, Instagram, LinkedIn, TikTok, and YouTube Establishment of brand identity and tone of voice',
        'Content strategy and calendar management'
      ],
      ge: [
        'კონტენტ მარკეტინგის საფუძვლები',
        'მარკეტინგის მიმდინარე ტენდენციები და საუკეთესო პრაქტიკები',
        'Facebook-ზე, Instagram-ზე, LinkedIn-ზე, TikTok-სა და YouTube-ზე კონტენტის შექმნა და მართვა',
        'ბრენდის იდენტობისა და სასაუბრო ტონის ჩამოყალიბება',
        'კონტენტ სტრატეგიისა და კალენდრის მართვა'
      ]
    },
    afterCourse: {
      ge: [
        'შექმნა თითოეულ არხზე მორგებული, მიმზიდველი კონტენტი',
        'შეიმუშაო და განახორციელო კონტენტ მარკეტინგის სტრატეგია',
        'გაზომო შენი კონტენტის წარმატება  და მიმდინარე სტრატეგიაში შეიტანო ცვლილებები',
        'გაზარდო ბრენდის ცნობადობა',
        'ამოიცნო და მიჰყვე ციფრული მარკეტინგის ტენდენციებს'
      ],
      en: [
        'Create engaging content tailored to each digital channel',
        'Develop and implement a content marketing strategy',
        'Measure the success of your content and make changes to your current strategy',
        'Increase brand awareness',
        'Identify and follow digital marketing trends'
      ]
    },
    fee: 599,
    syllabus: {
      ge: [
        {
          title: 'ნაწილი 1',
          sections: [
            'შესავალი კონტენტ მარკეტინგში',
            '2023 წლის ტრენდები',
            'კონტენტის სტილი',
            'მუდბორდები და რეფერენსები',
            'ბრენდის იდენტობა და ხმა, არხების მიხედვით'
          ]
        },
        {
          title: 'ნაწილი 2',
          sections: [
            'კონტენტ სტრატეგია და კალენდარი',
            'Facebook გვერდის შექმნა',
            'კონტენტი Facebook-ზე',
            'სხვადასხვა ფლეისმენთები Facebook-ზე',
            'სხვადასხვა ბრენდი Facebook-ზე'
          ]
        },
        {
          title: 'ნაწილი 3',
          sections: [
            'Instagram ექაუნთის შექმნა',
            'კონტენტი Instagram-ზე',
            'Instagram-ის ხრიკები',
            'როგორ შევქმნათ რილები'
          ]
        },
        {
          title: 'ნაწილი 4',
          sections: [
            'Tik Tok შესაძლებლობები საქართველოში',
            'Tik Tok-ის კონტენტი',
            'Tik Tok - ის ხრიკები'
          ]
        },
        {
          title: 'ნაწილი 5',
          sections: [
            'როგორი კონტენტი მუშაობს YouTube',
            'ცნობილი იუთუბერები და მათი ხრიკები',
            'LinkedIn დამწყებთათვის',
            'LinkedIn როგორც საკომუნიკაციო ხელსაწყო ბრენდებისთვის',
            'LinkedIn სტრატეგია',
            'როგორ ვავარჯიშოთ წარმოსახვა'
          ]
        }
      ],
      en: [
        {
          title: 'Block 1',
          sections: [
            'Introduction to Content Marketing',
            'Trends of 2023',
            'Content styles',
            'Moodboards & References',
            'Brand identity & TOV per channels'
          ]
        },
        {
          title: 'Block 2',
          sections: [
            'Content strategy & calendar',
            'Creating Facebook Page',
            'Content on Facebook',
            'Different placements on Facebook',
            'Different Brands on Facebook'
          ]
        },
        {
          title: 'Block 3',
          sections: [
            'Create Instagram account',
            'Content on Instagram',
            'Instagram Tips, Tricks & Hacks',
            'Creating original Reels'
          ]
        },
        {
          title: 'Block 4',
          sections: [
            'TikTok opportunities in Georgia',
            'Content on Tiktok',
            'TikTok Tips, Tricks & Hacks'
          ]
        },
        {
          title: 'Block 5',
          sections: [
            'What type of content works on YouTube',
            'Famous Youtubers and their tricks',
            'LinkedIn for Beginners',
            'LinkedIn as a communication tool for brands',
            'LinkedIn strategy',
            'Training your imagination'
          ]
        }
      ]
    }
  },
  {
    id: 39,
    image: ai,
    cover: '',
    sort: CourseSortEnum.AI,
    duration: 3,
    startDate: '26.06.2023',
    title: {
      en: 'Artificial Intelligence and AI Project Management ',
      ge: 'ხელოვნური ინტელექტი და AI პროექტების მართვა'
    },
    lesson: 3,
    layerCtgr: 'ai',
    shortDescription: {
      ge: 'კურსი განკუთვნილია ადამიანებისთვის, რომლებსაც სურთ გაეცნონ ხელოვნური ინტელექტისა და მისი მუშაობის პრინციპებს. ასევე, მათთვის, ვისაც უნდა ხელოვნური ინტელექტი ბიზნესსა და ყოველდღიურ საქმიანობაში გამოიყენოს. ამასთანავე, კურსის საშუალებით შესაძლებელია AI პროექტების მართვის შესწავლა და ხელოვნური ინტელექტის სხვა მრავალფეროვანი შესაძლებლობის აღმოჩენა.',
      en: 'The course is designed for people who want to learn about the principles of artificial intelligence and its work. Also, for those who want to use artificial intelligence in business and everyday life. In addition, the course allows you to study AI project management and discover other diverse AI capabilities.'
    },
    description: {
      en: 'The course provides an overview of Artificial Intelligence (AI) and its applications. It covers the history, goals, and milestones of AI. The course explores the challenges and opportunities in AI adoption, including organisational readiness and ethical considerations. It also dives deep into machine learning, neural networks, and deep learning. The syllabus includes case studies on various AI applications such as NLP, computer vision, self-driving cars, fraud detection, AI use cases in medicine, marketing and entertainment, concepts of generative AI and many more. Additionally, the course covers AI project management principles, including identifying business problems suitable for AI solutions, data collection and preprocessing, model selection and deployment, and privacy and ethical considerations. It also emphasises the human-centred design approach and project scoping, stakeholder management, and project evaluation',
      ge: 'კურსი მოიცავს ხელოვნური ინტელექტის (AI) და მისი გამოყენების მაგალითების მიმოხილვას. ის ასევე მოიცავს AI-ის ისტორიას, ისევე როგორც მისი მიზნების ახსნას და AI მოდელების შესაქმნელად საჭირო ეტაპების განხილვას. კურსი იკვლევს გამოწვევებსა და შესაძლებლობებს ხელოვნური ინტელექტის დანერგვაში, მათ შორის კომპანიის ორგანიზაციულ მზადყოფნასა და ეთიკურ მოსაზრებებს. ის ასევე სიღრმისეულად შეისწავლის მანქანურ სწავლებას, ნერვულ ქსელებსა და ღრმა დასწავლას. სილაბუსი მოიცავს სხვადასხვა ტიპის AI-ის გამოყენების ნიმუშების ახსნას, როგორიცაა ბუნებრივი ენის დამუშავება, კომპიუტერული ხედვა, თვითმართვადი მანქანები, თაღლითობის გამოვლენა, ხელოვნური ინტელექტის გამოყენების შემთხვევები მედიცინაში, მარკეტინგსა და გართობაში, გენერაციული AI-ს ცნებები და მრავალი სხვა. გარდა ამისა, კურსი მოიცავს AI პროექტების მართვის პრინციპებს, მათ შორის AI  გადაწყვეტილებისთვის შესაფერისი ბიზნეს პრობლემების იდენტიფიცირებას, მონაცემთა შეგროვებას, დამუშავებას და მოდელის შერჩევასა და დანერგვას'
    },
    courseFor: {
      en: 'This course is designed for individuals interested in gaining a comprehensive understanding of Artificial Intelligence (AI) and its applications. It is suitable for professionals from various backgrounds, including business, technology, and academia, who want to explore the potential of AI in solving problems and driving innovation. It is also beneficial for managers and decision-makers involved in tech project management or implementation. Prior knowledge of AI or programming is not required, as the course provides a foundational understanding of AI concepts and techniques',
      ge: 'ეს კურსი განკუთვნილია მათთვის, ვინც დაინტერესებულია ხელოვნური ინტელექტით (AI) და მისი გამოყენებით ბიზნესსა თუ ყოველდღიურ ცხოვრებაში. Კურსის გავლა შეუძლიათ ნებისმიერი ინდუსტრიის წარმომადგენლებს, მათ შორის ბიზნესის, ტექნოლოგიებისა და აკადემიის წარმომადგენლებისაც, რომელთაც სურთ გამოიკვლიონ ხელოვნური ინტელექტის პოტენციალი პრობლემების გადაჭრაში და ინოვაციების მართვაში. ის ასევე გამოსადეგია მენეჯერებისთვის და გადაწყვეტილების მიმღები პირებისთვის, რომლებიც ჩართული არიან ტექნიკური პროექტების მენეჯმენტში ან განხორციელებაში. ხელოვნური ინტელექტის ან პროგრამირების წინასწარი ცოდნა არ არის საჭირო, რადგან კურსი უზრუნველყოფს ხელოვნური ინტელექტის კონცეფციებისა და ტექნიკის საფუძვლიან გაგებას. კურსი არის ყველასთვის, ვისაც უნდა ააჩქაროს საკუთარი ცხოვრების ტემპი, ფეხი აუწყოს თანამედროვე მსოფლიოს გამოწვევებს ან გაზარდონ ბიზნესის ეფექტურობა'
    },
    youWillLearn: {
      en: [
        'History of AI',
        'Machine Learning, Deep Learning and Neural Networks principles',
        'How companies collect and label data',
        'How companies train and deploy models',
        'Different types of AI models (computer vision, NLP, etc)',
        'Usage of modern AI tools',
        'AI project management'
      ],
      ge: [
        'AI-ის ისტორია',
        'მანქანური სწავლების, ღრმა დასწავლისა და ნერვული ქსელების პრინციპები',
        'მონაცემთა შეგროვება და მარკირება',
        'მოდელების სწავლებისა და დანერგვის პროცესი',
        'AI მოდელების სხვადასხვა ტიპები (კომპიუტერული ხედვა, ბუნებრივი ენის დამუშავება და ა.შ.)',
        'თანამედროვე AI ხელსაწყოების გამოყენება',
        'AI პროექტების მართვა'
      ]
    },
    afterCourse: {
      ge: [
        'გაიგო AI პროექტების სრული სასიცოცხლო ციკლი',
        'შექმნა შენი საკუთარი AI მოდელები ნულიდან კოდის გარეშე ხელსაწყოების გამოყენების საშუალებით',
        'შეაფასო შენს ბიზნესში AI გადაწყვეტილებების დანერგვის ღირებულება და ეფექტი',
        'გქონდეს საფუძვლიანი ცოდნა თანამედროვე AI აპლიკაციებისა და გამოყენების მაგალითების შესახებ',
        'გამოიყენო AI ხელსაწყოები შენს ყოველდღიურ ცხოვრებაში',
        'დაიწყო მუშაობა AI პროექტების მენეჯერად'
      ],
      en: [
        'Understand the full lifecycle of AI projects',
        'Create your own AI models via no-code tools from scratch',
        'Assess the cost and effect of implementing AI solutions in your business ',
        'Have a thorough understanding of modern AI applications and use-cases ',
        'Use AI tools in your everyday life',
        'Start a job as an AI project manager'
      ]
    },
    fee: 699,
    syllabus: {
      ge: [
        {
          title: 'ნაწილი 1 - შესავალი ხელოვნურ ინტელექტში',
          sections: [
            'AI-ს განმარტება და მიზნები',
            'ორგანიზაციული მზადყოფნა AI-სთვის',
            'შესავალი მანქანურ სწავლებაში',
            'შესავალი ნერვულ ქსელებში',
            'მონაცემთა შეგროვება და მონაცემთა მარკირება',
            'მოდელის სწავლება და დანერგვა'
          ]
        },
        {
          title: 'რაში გამოიყენება AI და AI ხელსაწყოები',
          sections: [
            'ბუნებრივი ენის დამუშავების მაგალითები',
            'კომპიუტერული ხედვის მაგალითები',
            'თვითმართვადი მანქანები და თაღლითობის პრევენცია',
            'AI ჯანდაცვასა და ნუტრიციაში',
            'რა არის გენერაციული AI',
            'ChatGPT და სწრაფი ინჟინერია',
            'Midjourney, Synthesia ხელსაწყოების გამოყენება',
            'Fireflies, Notion, Charles ხელსაწყოების გამოყენება',
            'ნეტფლიქსის სარეკომენდაციო სისტემა',
            'AI მოდის ინდუსტრიაში',
            'გენერაციული AIს გამოყენება ფინანსებში',
            'გენერაციული AIს გამოყენება მარკეტინგში'
          ]
        },
        {
          title: 'ნაწილი 3 - AI პროექტების მართვა',
          sections: [
            'შესავალი AI პროექტების მართვაში',
            'AI პროექტების მართვა - სიღრმისეული განხილვა',
            'პროექტის დაგეგმვა',
            'Human/Model in the loop AI პროექტები'
          ]
        }
      ],
      en: [
        {
          title: 'Block 1 - Introduction To AI',
          sections: [
            'Definition and goals of AI',
            'Organizational readiness for AI',
            'Introduction to machine learning',
            'Introduction to neural networks',
            'Data Collection & Data Labeling',
            'Model Training & Deployment'
          ]
        },
        {
          title: 'Block 2 - AI Applications & Tools',
          sections: [
            'Case Study - NLP',
            'Case Study - Computer Vision Projects',
            'Case Study - Self Driving Cars & Fraud Detection',
            'Case Study - AI in Medicine and Food',
            'What is Generative AI',
            'Chatgpt & Prompt Engineering',
            'Midjourney, Synthesia',
            'Fireflies, Notion, Charles',
            'Netflix Recommender Engine',
            'AI in Fashion',
            'Finance Applications of Generative AI',
            'Marketing Applications of Generative AI'
          ]
        },
        {
          title: 'Block 3 - AI Project Management',
          sections: [
            'Introduction to AI project management',
            'Advanced AI Project Management',
            'Project Scoping',
            'Human/Model in the loop AI projects'
          ]
        }
      ]
    }
  }
  // {
  //   id: 27,
  //   image: english,
  //   cover: '',
  //   sort: CourseSortEnum.MARKETING,
  //   duration: 6,
  //   startDate: '06.2023',
  //   title: {
  //     en: 'General English Course',
  //     ge: 'ზოგადი ინგლისურის კურსი'
  //   },
  //   lesson: 3,
  //   layerCtgr: 'language',
  //   shortDescription: {
  //     ge: 'კურსი არის ნებისმიერი ადამიანისთვის, ვისაც აქვს ინგლისური ენის საბაზისო ცოდნა და სურს ენის საფუძვლიანად შესწავლა მოკლე დროში',
  //     en: 'This course is for anybody who has a basic knowledge of the English language and is looking for further education in a short period'
  //   },
  //   description: {
  //     en: 'The course aims to advance students’ ability to understand, write, read and speak in English. Also, it focuses on the practical use of the English language, such as learning widely used phrases, words and sentence structures. We teach the English language with proven methods and practices that have been used worldwide for the last 20 years. We are monitoring the students’ progress with regular tests and examinations. You will get a certificate after completing the course successfully.',
  //     ge: 'კურსის მიზანია ინგლისურ ენაზე მეტყველების, მოსმენის, წერის და კითხვის უნარების თანაბარ დონეზე განვითარება. ასევე, აქცენტი კეთდება ენის პრაქტიკულ ასპექტებზე, როგორიცაა სასაუბრო ინგლისური, გავრცელებული ფრაზები და სიტყვები, ხშირად გამოყენებადი გრამატიკული კონსტრუქციები. კურსში გამოყენებულია მრავალფეროვანი სასწავლო მასალა და ენის სწავლების საუკეთესო პრაქტიკები, რომლის ეფექტურობაც უკვე 20 წელზე მეტია უამრავი ადამიანის წარმატებული გამოცდილებით დასტურდება. შენი პროგრესის მონიტორინგი რეგულარული ტესტების და გამოცდების ჩატარებით იქნება შესაძლებელი. შენი წარმატების საფუძველზე კი, გადმოგეცემა დონის დამადასტურებელი სერტიფიკატი.'
  //   },
  //   youWillLearn: {
  //     en: [
  //       'Interesting assignments',
  //       'Regular feedback',
  //       'Q&A sessions',
  //       'The experience in speaking in English via phone-call-trainings',
  //       'Constant support from our tutors'
  //     ],
  //     ge: [
  //       'საინტერესო და განსხვავებული ფორმატის დავალებებს',
  //       'მუდმივ უკუკავშირს შენთვის საინტერესო ან/და გაუგებარ საკითხებზე',
  //       'Q&A სესიებს',
  //       'ინგლისურად საუბრის პრაქტიკას სატელეფონო ტრენინგების მეშვეობით',
  //       'მაქსიმალურ მხარდაჭერას ჩვენი ტუტორებისგან'
  //     ]
  //   },
  //   courseFor: {
  //     en: 'This course is for anybody who has a basic knowledge of the English language and is looking for further education in a short period. In this course, you will significantly improve your English with the help of the world’s leading methods, textbooks, other materials and the Skillwill program itself. You can take the course if you have a minimum level of English proficiency (A1)',
  //     ge: 'კურსი არის ნებისმიერი ადამიანისთვის, ვისაც აქვს ინგლისური ენის საბაზისო ცოდნა და სურს ენის საფუძვლიანად შესწავლა მოკლე დროში. შენ შეძლებ, მნიშვნელოვნად გაიღრმავო ენის პრაქტიკული ცოდნა მსოფლიოში მოწინავე მეთოდების, სახელმძღვანელოების, მასალების და სქილვილის პროგრამის მეშვეობით. კურსის გავლას შეძლებ, თუ გაქვს ინგლისური ენის მინიმალური ცოდნა (A1)'
  //   },
  //   afterCourse: {
  //     en: [
  //       'Properly speak in English about everyday topics',
  //       'Enrich your vocabulary',
  //       'Write e-mails, letters and short texts grammatically correctly',
  //       'Understand various types of materials in English, including audio, video and texts',
  //       'be confident to speak in English in formal and informal situations',
  //       'pass B1 level English language test'
  //     ],
  //     ge: [
  //       'ძირითად სასაუბრო თემებზე გამართულად მეტყველებას, სიტყვების სწორად გამოთქმას და სხვისი ნათქვამის ადვილად გაგებას',
  //       'გამოიყენო ზოგადი ინგლისური ენისთვის დამახასიათებელი ყველაზე გავრცელებული სიტყვების მარაგი სხვადასხვა თემაზე',
  //       'ელ.ფოსტების, წერილების და მოკლე ტექსტების წერას',
  //       'გამოიყენო სიტყვები და ფრაზები, რომელიც დაგეხმარება გამართულად კომუნიცირებაში ნებისმიერ დროს',
  //       'დამოუკიდებლად გაეცნო დონის შესაბამისი სირთულის ტექსტურ, აუდიო და ვიდეო მასალებს შენთვის საინტერესო თემაზე',
  //       'ისაუბრო თავდაჯერებულმა ფორმალურ და არაფორმალურ სიტუაციებში',
  //       'მოიხსნა ინგლისურ ენაზე საუბრის კომპლექსი',
  //       'გაიარო ინგლისური ენის B1 დონის კურსი'
  //     ]
  //   },
  //   fee: 599,
  //   syllabus: {
  //     ge: [
  //       {
  //         id: 1,
  //         title: 'ლექსიკის ნაწილი',
  //         sections: [
  //           'ინგლისურ ენაში ყველაზე გავრცელებული 1000 სიტყვა ',
  //           'Cambridge-ის Key English Test (KET)-ის ჩასაბარებლად საჭირო ლექსიკა',
  //           'გავრცელებული ფრაზები და სიტყვათა შეთანხმებები, იდიომები, ფრაზული ზმნები და არაწესიერი ზმნები',
  //           'სინონიმები და ანტონიმები',
  //           'სიტყვების წარმოება',
  //           'თემატური ლექსიკა: რიცხვები და ფერები',
  //           'თემატური ლექსიკა: კალენდარი, დრო და ამინდი',
  //           'თემატური ლექსიკა: ქვეყნები და ეროვნებები',
  //           'თემატური ლექსიკა: პირადი ინფორმაცია',
  //           'თემატური ლექსიკა: სხეული და სახე',
  //           'თემატური ლექსიკა: ოჯახი და მეგობრები',
  //           'თემატური ლექსიკა: საკვები და სასმელი',
  //           'თემატური ლექსიკა: ტანსაცმელი',
  //           'თემატური ლექსიკა: საცხოვრებელი',
  //           'ფული და საყიდლები',
  //           'ყოველდღიურობა',
  //           'პროფესიები',
  //           'სწავლა და მუშაობა',
  //           'საკლასო ოთახი და სკოლა',
  //           'სასკოლო საგნები',
  //           'თავისუფალი დრო და ჰობი',
  //           'სპორტი',
  //           'თემატური ლექსიკა: განტვირთვა და დასვენება',
  //           'თემატური ლექსიკა: მნიშვნელოვანი ადგილები ქალაქში',
  //           'თემატური ლექსიკა: ტრანსპორტი და მიმართულების ჩვენება',
  //           'თემატური ლექსიკა: მოგზაურობა',
  //           'თემატური ლექსიკა: ჯანმრთელობა და უსაფრთხოება',
  //           'თემატური ლექსიკა: ადამიანები',
  //           'თემატური ლექსიკა: საზოგადოება',
  //           'თემატური ლექსიკა: ყოველდღიური ინგლისური',
  //           'თემატური ლექსიკა: წეს-ჩვეულებები და ტრადიციები',
  //           'თემატური ლექსიკა: ტექნოლოგიები',
  //           'თემატური ლექსიკა: ხელოვნება ',
  //           'თემატური ლექსიკა: გლობალური პრობლემები',
  //           'თემატური ლექსიკა: დედამიწა და კოსმოსი '
  //         ]
  //       },
  //       {
  //         id: 2,
  //         title: 'გრამატიკის ნაწილი',
  //         sections: [
  //           'გრამატიკული დროები',
  //           'ზმნა "ყოფნა": აწმყო',
  //           'მარტივი აწმყო დრო',
  //           'სიხშირის ზმნიზედები',
  //           'აწმყო განგრძობითი',
  //           'სტატიკური ზმნები',
  //           'ზმნა "ყოფნა": წარსული',
  //           'მარტივი წარსული დრო',
  //           'წარსული განგრძობითი ',
  //           'აწმყო დასრულებული მარტივი',
  //           'აწმყო დასრულებული განგრძობითი',
  //           'წარსულის წარსული',
  //           'წარსულის ჩვევები',
  //           'მომავალი დრო',
  //           'კონსტრუქცია "Be going to"',
  //           'მომავალი "Shall"',
  //           'აწმყო დროები მომავლის გამოსახატავად',
  //           'წინადადებები და კითხვები',
  //           'მეტყველების ნაწილები',
  //           'სიტყავათა თანმიმდევრობა წინადადებაში',
  //           'კონსტრუქცია',
  //           'შეკითხვების დასმა: “Yes/No” questions',
  //           'კითხვით სიტყვებზე დაწყებული შეკითხვების დასმა',
  //           'კონსტრუქცია "What...like?',
  //           'ნათქვამის დასაზუსტებელი კითხვები',
  //           'მოკლე პასუხები',
  //           'მოდალური ზმნები',
  //           'უნარი და ნებართვა',
  //           'ვალდებულება',
  //           'რჩევის მიცემა',
  //           'შესაძლებლობა და ალბათობა ',
  //           'დარწმუნებულობა ',
  //           'არტიკლები, არსებითი სახელები, ნაცვალსახელები და ა.შ.',
  //           'განუსაზღვრელი არტიკლი ',
  //           'განსაზღვრული არტიკლი ',
  //           'არტიკლის გარეშე ',
  //           'მრავლობითი არსებითი სახელები ',
  //           'თვლადი და უთვლადი არსებითი სახელები ',
  //           'არსებითი სახელის განმსაზღვრელი სიტყვები სიტყვები ',
  //           'კუთვნილებითი ნაცვალსახელები ',
  //           'განსაზღვრული და განუსაზღვრელი ნაცვალსახელები ',
  //           'რაოდენობის განმსაზღვრელი სიტყვები ',
  //           'პირდაპირი და არაპირდაპირი ობიექტი ',
  //           'ზედსართავი სახელები და ზმნიზედები ',
  //           'ზედსართავი სახელების თანმიმდევრობა წინანადადებაში',
  //           '" -ed" ან "-ing"-ით დაბოლოვებული ზედსართავი სახელები ',
  //           'ნატურალური და რიგითი რიცხვები ',
  //           'შედარებითი ზედსართავი სახელები ',
  //           'აღმატებითი ზედსართავი სახელები ',
  //           'სიხშირის, ადგილის, მიმართულების და თანმიმდევრობის ზმნიზედები',
  //           'ზმნიზედის ადგილმდებარეობა წინადადებაში ',
  //           'წინდებულები ',
  //           'ადგილის, მოძრაობის და დროის წინდებულები ',
  //           'წინდებულების სხვა გამოყენებები ',
  //           'ზმნა + წინდებული ',
  //           'ზედსართავი + წინდებული ',
  //           'ზმნები ',
  //           'ვნებითი გვარი ',
  //           'ვნებითი გვარი: ზმნები Have, get, make ',
  //           'ფრაზული ზმნები ',
  //           'კონტრუქცია "Would like" ',
  //           'ზმნა + გერუნდი ',
  //           'ზმნა + ინფინიტივი ',
  //           'პირობითი წინადადებები ',
  //           'ნულოვანი ',
  //           'პირველი',
  //           'მეორე ',
  //           'მესამე ',
  //           'სხვისი ნათქვამის გამეორება ',
  //           'გრამატიკული დროების შეცვლის წესი ',
  //           'ცალკეული სიტყვების შეცვლის წესი ',
  //           'მაკავშირებელი სიტყვები ',
  //           'მიმართებითი დამოკიდებული წინადადები ',
  //           'მიმართებითი დამოკიდებული წინადადები ',
  //           'არაგანმსაზღვრელი მიმართებითი დამოკიდებული წინადადები '
  //         ]
  //       },
  //       {
  //         id: 3,
  //         title: 'მეტყველების ნაწილი ',
  //         sections: [
  //           'მისალმებები და დამშვიდობები',
  //           'წარდგენები',
  //           'საკუთარ თავზე საუბარი: სახელი და გვარი, მისამართი, ტელეფონის ნომერი, დაბადების ადგილი, ასაკი, ეროვნება, დაბადების თარიღი',
  //           'სახელის და გვარის დამარცვლა ',
  //           'საუბრის დაწყება და დასრულება ',
  //           'საკუთარი თავზე, ოჯახზე, მეგობრებზე, საცხოვრებელ ადგილზე, ჰობიზე, ინტერესებსა და განათლებაზე საუბარი ',
  //           'ჩვევების და ყოველდღიური რუტინის აღწერა ',
  //           'წარსულის მოვლენებზე საუბარი ',
  //           'ადამიანების, ადგილების და ნივთების აღწერა ',
  //           'წარმოსახვითი სიტუაციების აღწერა ',
  //           'სურათის ან ფოტოს აღწერა ',
  //           'სამედიცინო სიმპტომების აღწერა ',
  //           'დაპირებების და შეთავაზებების გაკეთება ',
  //           'შედარების გაკეთება ',
  //           'ექიმთან ვიზიტის დაგეგმვა ',
  //           'მომავლის გეგმებზე საუბარი ',
  //           'რჩევის მიცემა ',
  //           'კომპლიმენტების გაკეთება და მილოცვა ',
  //           'მიმართულების ჩვენება ',
  //           'ვალდებულებებსა და აკრძალვებზე საუბარი ',
  //           'მოწონების/არმოწონების და თნხმობის/არდათანხმების გამოხატვა',
  //           'ემოციებისა და გრძნობების გამოხატვა ',
  //           'შეკითხვების დასმა და მადლობის თქმა ',
  //           'ინფორმაციის გამოთხოვნა და ნებართვის მიღება',
  //           'ბოდიშის მოხდა და სინანულის გამოხატვა ',
  //           'ნათქვამის დაზუსტების მოთხოვნა ',
  //           'ზრდილობიანი და არაზრდილობიანი საუბრის გარჩევა ',
  //           'დაპატიჟება, მოწვევის მიღება ან მოწვევაზე უარის თქმა ',
  //           'ფერების, ფორმების და რიცხვების შესატყვისი ლექსიკის საუბარში გამოყენება ',
  //           'დროზე, კვირის დღეებზე, თვეებზე და ამინდზე საუბარი ',
  //           'რესტორანში შეკვეთის გაკეთება ',
  //           'საყიდლების გაკეთება ',
  //           'საზოგადოებრივი ტრანსპორტის გამოყენება ',
  //           'საგანგებო ვითარება: სასწრაფოსთან ზარი, საგანგებო ვითარების აღწერა, ადგილმდებარეობის შეტყობინება ',
  //           'გამოთქმებზე მუშაობა '
  //         ]
  //       },
  //       {
  //         id: 4,
  //         title: 'მოსმენის ნაწილი',
  //         sections: [
  //           'ყოველდღიური დიალოგებისა და საუბრების ძირითადი შინაარსის გაგება',
  //           'მარტივი სატელეფონო საუბრის გაგება ',
  //           'პირადი, ოჯახის, სამსახურის, საყიდლების და სხვა მარტივი თემების შესახებ ინფორმაციის გაგება ',
  //           'მოკლე და მარტივი მესიჯების და განცხადებების გაგება ',
  //           'პოპულარულ თემებზე სატელევიოზიო/რადიო გადაცემების, ინტერვიუების და ფილმებიდან/ ვიდეოებიდან ამონარიდების მთავარი აზრის გაგება ',
  //           'ყოველდღიური საუბრის გაგება (ნელა და მკაფიოდ გამოთქმული) ',
  //           'ვიდეო რეცეპტების გაგება '
  //         ]
  //       },
  //       {
  //         id: 5,
  //         title: 'წერის ნაწილი',
  //         sections: [
  //           'ტიპიური დღის აღწერა ',
  //           'დასვენების გეგმების აღწერა ',
  //           'ცხოვრებისეული ცვლილებების აღწერა ',
  //           'მოკლე იმეილების და მოკლეტექსტური შეტყობინებების წერა ',
  //           'მეგობრისთვის წერილის/იმეილის მიწერა: რჩევის ან ინფორმაციის მიცემა სხვადასხვა საკითხზე ',
  //           'მოწვევის მიწერა/მოწვევაზე უარის თქმა ',
  //           'მომხდარის აღწერა ',
  //           'შენთვის საინტერესო ადგილის აღწერა ',
  //           'საფოსტო ბარათის დაწერა',
  //           'დროის, თარიღების და რიცხვების სიტყვებით წერა '
  //         ]
  //       },
  //       {
  //         id: 6,
  //         title: 'წაკითხვის ნაწილი',
  //         sections: [
  //           'ყოველდღიური თემებზე მოკლე პირადი შეტყობინებების და წერილების წაკითხვა',
  //           'ნაცნობ თემებზე მოკლე ამბების წაკითხვა ',
  //           'ცნობილი ადამიანების შესახებ ადაპტირებული ბიოგრაფიების წაკითხვა ',
  //           'რეკლამებსა და განცხადებებში მთავარი აზრის გაგება ',
  //           'ახალი ამბის ან სტატიის მთავარი სათქმელის გაგება',
  //           'ფილმის/სპექტაკლის მარტივი მიმოხილვის წაკითხვა ',
  //           'შვებულების, ქალაქის, სასტუმროს შესახებ ბროშურის წაკითხვა ',
  //           'ონლაინ რუკების გამოყენება',
  //           'რიცხვების, დროისა და თარიღების შესაბამისი სიტყვების სწორად წაკითხვა და აღქმა ',
  //           'კითხვარების წაკითხვა და გაგება (თუ რა ინფორმაციის შევსებას ითხოვენ) ',
  //           'მოწყობილობების გამოსაყენებლად მარტივი ისტრუქციების წაკითხვა ',
  //           'საყიდლებთან დაკავშირებული სიმბოლიკის ცნობა: ფასები, ფასდაკლებები, სარეკლამო განცხადებები, "გასახდელი ოთახი", ვალუტა, ფულის ცნობა და ა.შ. ',
  //           'ამკრძალავ განცხადებებთან დაკავშირებული სიმბოლიკის ცნობა: შხამიანი ნივთიერებები, საგანგებო სიტუაციები, "მოწევა აკრძალულია", "მარტივად აალებადია", "საშიშია", "ყურადღება" და ა.შ. ',
  //           'საზოგადოებრივ დაწესებულებებთან დაკავშირებული სიმბოლიკის ცნობა: საპირფარეშო, შესასვლელი, გასასვლელი, პარკინგი ',
  //           'ავტობანთან და მოგზაურობასთან, სიჩქარის შეზღუდვის, პარკირების ზონების და ა.შ. დაკავშირებული ლექსიკისა და სიმბოლიკის ცნობა '
  //         ]
  //       },
  //       {
  //         id: 7,
  //         title: 'სხვა',
  //         sections: [
  //           'სიტყვების სწორი გამოთქმა',
  //           'ტრანსკრიფცია',
  //           'მარლთწერა ',
  //           'სასვენი ნიშნები ',
  //           'შემოკლებები ',
  //           'დამატებითი ვიდეო-აუდიო მასალები '
  //         ]
  //       }
  //     ],
  //     en: [
  //       {
  //         id: 1,
  //         title: 'Vocabulary',
  //         sections: [
  //           'Sight words',
  //           'Key English Test (KET) Vocabulary List',
  //           'Common phrases and collocations, common idioms, common phrasal verbs, common irregular verbs',
  //           'Synonyms and antonyms',
  //           'Word formation',
  //           'Topic vocabulary: numbers and colours',
  //           'Topic vocabulary: calendar, time and weather',
  //           'Topic vocabulary: countries and nationalities',
  //           'Topic vocabulary:personal information',
  //           'Topic vocabulary:body and face',
  //           'Topic vocabulary: family and friends',
  //           'Topic vocabulary: food and drink',
  //           'Topic vocabulary: clothes',
  //           'Topic vocabulary: housing',
  //           'Topic vocabulary: money and shopping',
  //           'Topic vocabulary: everyday life',
  //           'Topic vocabulary: jobs',
  //           'Topic vocabulary: study and work',
  //           'Topic vocabulary: class and school',
  //           'Topic vocabulary: school subjects',
  //           'Topic vocabulary: free time and hobbies',
  //           'Topic vocabulary: sport',
  //           'Topic vocabulary: recreation and holidays',
  //           'Topic vocabulary: places',
  //           'Topic vocabulary: transportation and directions',
  //           'Topic vocabulary: travel',
  //           'Topic vocabulary: health and safety',
  //           'Topic vocabulary: people',
  //           'Topic vocabulary: community',
  //           'Topic vocabulary: social english',
  //           'Topic vocabulary: customs and traditions',
  //           'Topic vocabulary: technology',
  //           'Topic vocabulary: the arts',
  //           'Topic vocabulary: animals, plants and nature',
  //           'Topic vocabulary: global problems',
  //           'Topic vocabulary: earth and space'
  //         ]
  //       },
  //       {
  //         id: 2,
  //         title: 'Grammar',
  //         sections: [
  //           'Tenses',
  //           'Be: present',
  //           'Present simple',
  //           'Frequency adverbs',
  //           'Present continuous',
  //           'Stative verbs',
  //           'Be: past',
  //           'Past simple',
  //           'Past continuous',
  //           'Present perfect simple',
  //           'Present perfect continuous',
  //           'Past perfect',
  //           'Past habits: used to',
  //           'Future',
  //           '"Be going to"',
  //           '"Shall"',
  //           'Present tenses for the future',
  //           'Parts of speech',
  //           'Word order: subject, verb, object',
  //           'There + be',
  //           '“Yes/No” questions',
  //           'Wh- questions: where, when, why, who, what, which; how/ how long/far/often...?',
  //           '"What...like?"',
  //           'Question tags',
  //           'Short ansvers',
  //           'Modal verbs',
  //           'Ability and permission',
  //           'Obligation',
  //           'Advice',
  //           'Possibility and probability',
  //           'Certainty',
  //           'Articles, nouns, pronouns, etc.',
  //           'Idefinite articles',
  //           'Definite article',
  //           'No article',
  //           'Plural nouns',
  //           'Countable and uncountable nouns',
  //           'Demonstrative determiners',
  //           'Possessive determiners',
  //           'Definite and indefinite pronouns',
  //           'Quantifiers',
  //           'Direct and indirect objects',
  //           'Adjectives and adverbs',
  //           'Order of adjectives',
  //           'Adjectives: -ed or -ing',
  //           'Cardinal and ordinal numvers',
  //           'Comparative adjectives',
  //           'Superlative adjectives',
  //           'Adverbs of frequency, place, direction, sequence',
  //           'Position of adverb in a sentence',
  //           'Prepositions',
  //           'Prepositions of place, movement and time',
  //           'Other uses of prepositions',
  //           'Verb + preposition',
  //           'Adjective + preposition',
  //           'Verbs',
  //           'Passive sentences',
  //           'Passive: have, get, make',
  //           'Phrasal verbs',
  //           '"Would like"',
  //           'Verb + gerund',
  //           'Verb + infinitive',
  //           'Conditionals',
  //           'Zero conditional',
  //           'First conditional',
  //           'Second conditional',
  //           'Third conditional',
  //           'Reported speech',
  //           'Tense changes',
  //           'Other changes',
  //           'Linking words',
  //           'Realtive clauses',
  //           'Relative clauses',
  //           'Non-defining relative clauses'
  //         ]
  //       },
  //       {
  //         id: 3,
  //         title: 'Speaking',
  //         sections: [
  //           'Greetings and goodbyes',
  //           'Introductions',
  //           'Giving personal identity information: name, address, phone number, country of origin, age, nationality, birth date',
  //           'Spelling of first and last names',
  //           'Beginning and ending conversations',
  //           'Describing oneself, family, friends, vhere one lives, hobbies and interests, educational background',
  //           'Describing habits and routines',
  //           'Describing past events and experiences',
  //           'Describing people, places and things',
  //           'Describing imaginary situations',
  //           'Describing a picture or photo',
  //           'Describing medical symptoms',
  //           'Making promises and offers',
  //           'Making comparisons',
  //           'Making appointments with doctors',
  //           'Talking about future plans and arrangements',
  //           'Giving advice',
  //           'Giving compliments and congratulations',
  //           'Giving simple directions',
  //           'Expressing obligation & prohibition',
  //           'Expressing likes/dislikes, agreement/disagreement',
  //           'Expressing emotions and feelings',
  //           'Asking and thanking',
  //           'Asking for information and permission',
  //           'Apologizing and expressing regret',
  //           'Asking for clarification',
  //           'Polite and impolite language',
  //           'Invitations: making, accepting and refusing',
  //           'Using color and shape names, ordinal numbers',
  //           'Telling time, days of the week and months of the year, weather conditions and temperature',
  //           'Express orders for food and drink',
  //           'Making simple purchases',
  //           'Using public transport',
  //           'Emergencies: emergency calls, describing the emergency, giving the location',
  //           'Working on pronunciation'
  //         ]
  //       },
  //       {
  //         id: 4,
  //         title: 'Listening',
  //         sections: [
  //           'Understanding the main points in everyday dialogues and conversations',
  //           'Understanding basic telephone conversations',
  //           'Understanding information about personal and family information, employment, shopping, etc.',
  //           'Understanding short clear messages and announcements',
  //           'Understanding the main points of tv/radio programms and interviews on popular topics',
  //           'Understanding simple everyday conversation spoken clearly and slovly',
  //           'Working with video recipes'
  //         ]
  //       },
  //       {
  //         id: 5,
  //         title: 'Writing',
  //         sections: [
  //           'A description of a typical day',
  //           'A description of holiday plans',
  //           'A description of recent changes i have made (at home or in my life)',
  //           'Writing short emails and text messages',
  //           'Writing a letter/ email to a friend (giving advice or information about clothes and weather, working conditions, customs and traditions, etc.)',
  //           'Inviting/refusing invitations',
  //           'Writing about something that happened to me or another person',
  //           'A description of a place of interest',
  //           'Writing a postcard',
  //           'Writing number vords, time and dates'
  //         ]
  //       },
  //       {
  //         id: 6,
  //         title: 'Reading',
  //         sections: [
  //           'Reading simple personal messages and letters about everyday life',
  //           'Reading short narratives about familiar topics',
  //           'Understanding adapted biographies of famous people',
  //           'Understanding simple information in advertisements or notices',
  //           'Understanding the main topic in news or simple articles',
  //           'Understand simple film/theatre reviews',
  //           'Understanding brochures (of a town, holiday, hotel)',
  //           'Using online direction service/ maps',
  //           'Recognizing number words, time and dates',
  //           'Understanding questionnaires',
  //           'Reading simple instructions for using equipment',
  //           'Understanding symbols for prices, sales, ads, fitting room, etc., recognizing money',
  //           'Understanding symbols for poison, emergency, no smoking, flammable, danger, caution and so on',
  //           'Signs and symbols for restrooms, entrance, exit, parking',
  //           'Understanding highway and travel words and symbols, speed limits, parking zones, emergency equipment for car'
  //         ]
  //       },
  //       {
  //         id: 7,
  //         title: 'Other',
  //         sections: [
  //           'Pronunciation',
  //           'Transcription',
  //           'Spelling',
  //           'Punctuation',
  //           'Contractions',
  //           'Additional audio and video materials'
  //         ]
  //       }
  //     ]
  //   }
  // }
];
